import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Sidebar } from "../Sidebar";
import ModuleNavbar from "../ModuleNavbar";
import "boxicons/css/boxicons.min.css";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import api from "../Authentication/authService";
import { Await, Link, Navigate, useNavigate } from "react-router-dom";
import { Alert } from "bootstrap";
import { PaymentStatus } from "../../context/PaymentStatusSlice";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import CircularProgress from "@mui/material/CircularProgress";
import { useLocation } from "react-router-dom";
import { CONFIG } from "../../config";
import { FocusTrap } from "focus-trap-react";
import Toast from "../../Toast/Toast";
import PaymentPlansSkeleton from "../Skeleton/PaymentPlanSkeleton";
import PaymentDashboardSkeleton from "../Skeleton/PaymentSkeleton";

export default function Payments() {
  

  const location = useLocation();
  const [toast, setToast] = useState(null);
  useEffect(() => {
    // refetch payment status
     setIsCommonModelOpen(false);
     setIsAgreed(false);
     setIsProcessingPayment(true)
  }, [location.key]);

  const [customerRights, setCustomerRights] = useState([
    {
      regular_Notice: "",
      soL_Notice: "",
      privacy_Link: "",
      privacyFlag: false,
    },
  ]);
  const [specialOffer, setSpecialOffer] = useState(false);
  const [payFull, setPayFull] = useState(false);
  const [Installment, setInstallment] = useState(false);
  const [partial, setPartial] = useState(false);
  const [showInstallment, setShowInstallment] = useState(false);
  const [showRemainingInstallment, setShowRemainingInstallment] = useState(false);
  const [showRemainingInstallmentPartialPayment, setShowRemainingInstallmentPartialPayment] = useState(false);
  const [showPartial, setShowPartial] = useState(false);


  const [paymentData, setPaymentData] = useState({
    fullBalance:"",
    actualBalance: "",
    settlementBalance: "",
    setBalance: "",
    settlementFlag: 0,
    paidAmount: 0,
    otherPay: false,
    specialOfferPay: false,
    payInFull: false,
    specialOfferDisable: false,
    planAllow : false
  });
  const { CredenceAccountNumber } = useSelector(
    (state) => state.Authentication
  );
  const MySwal = withReactContent(Swal);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [proceedBarOpen, setProceedBarOpen] = useState(false);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isScheduleModelOpen, setIsScheduleModelOpen] = useState(false);
  const [isCommonModelOpen, setIsCommonModelOpen] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [payableAmount, setPayableAmount] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [isScheduleChecked, setIsScheduleChecked] = useState(false);
  const [isBtnDisable, setIsBtnDisable] = useState(true);
  const [isScheduleBtnDisable, setIsScheduleBtnDisable] = useState(true);
  const [amount, setAmount] = useState(0);
  const [amountSpecialOffer, setAmountSpecialOffer] = useState(0);
  const [amountPartialPayment, setAmountPartialPayment] = useState(0);

  const [saleAmount, setSaleAmount] = useState(0);
  const [saleAmountSpecialOffer, setSaleAmountSpecialOffer] = useState(0);
  const [saleAmountPartialPayment, setSaleAmountPartialPayment] = useState(0);

  const [convenienceFee, setConvenienceFee] = useState(0);
  const [convenienceFeeSpecialOffer, setConvenienceFeeSpecialOffer] = useState(0);
  const [convenienceFeePartialPayment, setConvenienceFeePartialPayment] = useState(0);
  const { paymentStatus, paymentPlanStatus, actualBalance, merchantStatus } = useSelector(
    (state) => state.PaymentStatus
  );
  const [isError, setIsError] = useState("");
  const [pifFlag, setPifFlag] = useState(false);
  const [sifFlag, setSifFlag] = useState(false);
  const [otherPayFlag, setOtherPayFlag] = useState(false);
  const [otherAmountErrorMsg, setOtherAmountErrorMsg] = useState("");
  //console.log( paymentStatus , paymentPlanStatus )
  const [AccountInfo, setAccountInfo] = useState({
    accountOpenDate: null,
    credenceAccountNumber: "",
    creditorName: "",
    currentBalance: 0,
    customerEmail: "",
    dateOfService: "",
    firstName: "",
    lastName: "",
    originalCreditorName: null,
    setBalance: 0,
    settlementAmount: 0,
    zip: "",
    state: "",
    setCount: ""
  });
  const formikRef = useRef();
  const frequencyRef = useRef();
  const frequencyRefSpecialOffer = useRef();
  const frequencyRefPartialPayment = useRef();
  const [externalStateTotalAmount, setExternalStateTotalAmount] = useState(""); // External state for 'totalAmount'
  const [externalStateTotalAmountSpecialOffer, setExternalStateTotalAmountSpecialOffer] = useState(""); // External state for 'totalAmountSpecialOffer'
  const [externalStateTotalAmountPartialPayment, setExternalStateTotalAmountPartial] = useState(""); // External state for 'totalAmountPartialPayment'
  const [installmentAmountErrorMessage, SetInstallmentAmountErrorMessage] = useState("");
  const [installmentAmountErrorMessageSpecialOffer, SetInstallmentAmountErrorMessageSpecialOffer] = useState("");
  const [installmentAmountErrorMessagePartialPayment, SetInstallmentAmountErrorMessagePartialPayment] = useState("");
  const [isPayNowAndScheduleChecked, setIsPayNowAndScheduleChecked] = useState(false);
  const [selectedRadioValue, setSelectedRadioValue] = useState(null);
  const [otherAmountValue, setOtherAmountValue] = useState("");
  const [minRequiredAmount, setMinRequiredAmount] = useState(0);
  const [minRequiredAmountSpecialOffer, setMinRequiredAmountSpecialOffer] = useState(0);
  const [minRequiredAmountPartialPayment, setMinRequiredAmountParttialPayment] = useState(0);
  const [scheduleOtherAmountSection, setScheduleOtherAmountSection] = useState(false);
  const [paymentPlanExist, setPaymentPlanExist] = useState(false);
  const [paymentPlanExistSpecialOffer, setPaymentPlanExistSpecialOffer] = useState(false);
  const [paymentPlanExistPartialPayment, setPaymentPlanExistPartialPayment] = useState(false);
  const [paymentSchedule, setPaymentSchedule] = useState(null);
  const [paymentScheduleSpecialOffer, setPaymentScheduleSpecialOffer] = useState(null);
  const [paymentSchedulePartialPayment, setPaymentSchedulePartialPayment] = useState(null);
  const [payImmediate, setPayImmediate] = useState("");
  const [remainingAmount, setRemainingAmount] = useState("");
  const [convenience, setConvenience] = useState(0.00);
  const [convenienceSpecialOffer, setConvenienceSpecialOffer] = useState(0.00);
  const [conveniencePartialPayment, setConveniencePartialPayment] = useState(0.00);
  const [partialAmountError, setPartialAmountError] = useState("");
  const formikRefRemainingSpecialOffer = useRef();

  const formikRefRemainingPartialPayment = useRef();

  useEffect(() => {
    api.get(`${apiUrl}/CustomerRights/${CredenceAccountNumber}`).then((res) => {
      //console.log(res.data)
      setCustomerRights(res.data);
      //console.log(res.data);
    });
  }, [CredenceAccountNumber]);
// const convertToTimeStamp = (date) => {
//   console.log("Original date:", date); 
//   const [day, month, year] = date.split('/');

//   const formattedDate = new Date(`${year}-${month}-${day}`);

 
//   const timestamp = formattedDate.getTime();

//   console.log("Timestamp:", timestamp); 
//   return timestamp;
// };

const convertToTimeStamp = (date) => {
  const [day, month, year] = date.split('/');


  const timestamp = Date.UTC(
    Number(year),
    Number(month) - 1, 
    Number(day)
  );

  return timestamp;
};

const convertStartDateToTimeStamp = (date) => {
  const [year, month,day ] = date.split('-');


  const timestamp = Date.UTC(
    Number(year),
    Number(month) - 1, 
    Number(day)
  );

  return timestamp;
};


  useEffect(() => {
    api
      .get(`${apiUrl}/CustomerInformation/${CredenceAccountNumber}`)
      .then((response) => {
        if (response.status === 200) {
          setAccountInfo(response.data);
          //console.log(response.data)
        } else {
          // MySwal.fire({
          //   title: 'Error!',
          //   text: 'Something went wrong, please try again.',
          //   icon: 'error',
          //   confirmButtonText: 'Try Again',
          // });
        }
      })
      .catch((error) => {
        // console.error("API error:", error);
        // alert("Error occurred, please try again.");
      });
  }, [CredenceAccountNumber]);

  // PAY FULL AMOUNT 
  const handlePaymentSubmit = (values) => {
    setIsBtnDisable(true);
    setIsChecked(false);
    let isValidate = true;
    let amountToPay;
    amountToPay = paymentData.actualBalance;
    setPayableAmount(amountToPay);
    setPifFlag(true);
    setSifFlag(false);
    setOtherPayFlag(false);
    if (!isValidate) return;
    try {
      api

        .post(`${apiUrl}/PaymentFee`, {
          credenceAccountNumber: CredenceAccountNumber,

          amount: amountToPay,
        })

        .then((response) => {
          //console.log(response);

          if (response.status == 200) {
            setIsModelOpen(true);

            setConvenienceFee(response.data.adjAmount);

            setAmount(response.data.amount);

            setSaleAmount(response.data.saleAmount);
          }
        })

        .catch(() => { });
    } catch (error) { }
  };

  // PAY OFFER AMOUNT
  const handleOfferPaymentSubmit = (values) => {
    setIsBtnDisable(true);
    setIsChecked(false);
    let isValidate = true;
    let amountToPay;
    amountToPay = paymentData.settlementBalance;
    setPayableAmount(amountToPay);
    setSifFlag(true);
    setPifFlag(false);
    setOtherPayFlag(false);
    if (!isValidate) return;
    try {
      api

        .post(`${apiUrl}/PaymentFee`, {
          credenceAccountNumber: CredenceAccountNumber,

          amount: amountToPay,
        })

        .then((response) => {
          //console.log(response);

          if (response.status == 200) {
            setIsModelOpen(true);

            setConvenienceFeeSpecialOffer(response.data.adjAmount);

            setAmountSpecialOffer(response.data.amount);

            setSaleAmountSpecialOffer(response.data.saleAmount);
          }
        })

        .catch(() => { });
    } catch (error) { }
  };

  // PAY PARTIAL AMOUNT
  const [partialPaymentAmount, setPartialPaymentAmount] = useState(0);

  const handlePartialPaymentSubmit = (values) => {
    setIsBtnDisable(true);
    setIsChecked(false);
    let isValidate = true;
    let amountToPay;
    amountToPay = partialPaymentAmount;
    setPayableAmount(amountToPay);
    setOtherPayFlag(true);
    setSifFlag(false);
    setPifFlag(false);
    if (!isValidate) return;
    try {
      api

        .post(`${apiUrl}/PaymentFee`, {
          credenceAccountNumber: CredenceAccountNumber,

          amount: Number(amountToPay),
        })

        .then((response) => {
          //console.log(response);

          if (response.status == 200) {
            setIsModelOpen(true);

            setConvenienceFeePartialPayment(response.data.adjAmount);

            setAmountPartialPayment(response.data.amount);

            setSaleAmountPartialPayment(response.data.saleAmount);
          }
        })

        .catch(() => { });
    } catch (error) { }
  };

  //UPDATE CONVINENCE FOR PARTIAL PAYMENT
  const updateConvenienceForPartial = (value) => {
    setIsBtnDisable(true);
    setIsChecked(false);
    let isValidate = true;
    let amountToPay;
    amountToPay = value;
    setPayableAmount(amountToPay);
    setOtherPayFlag(true);
    if (!isValidate) return;
    try {
      api

        .post(`${apiUrl}/PaymentFee`, {
          credenceAccountNumber: CredenceAccountNumber,

          amount: Number(value),
        })

        .then((response) => {
          //console.log(response);

          if (response.status == 200) {
            setIsModelOpen(true);

            setConvenienceFeePartialPayment(response.data.adjAmount);

            setAmountPartialPayment(response.data.amount);

            setSaleAmountPartialPayment(response.data.saleAmount);
          }
        })

        .catch(() => { });
    } catch (error) { }
  }


  // PAY FULL/FULL OFFER/FULL PARTIAL AMOUNT (PAYMENT) 
  const handlePayment = async () => {
    try {
      await api
        .post(`${apiUrl}/Payment`, {
          credenceAccountNumber: CredenceAccountNumber,
          amount: Number(payableAmount),
          PIFFlag: pifFlag,
          SIFFlag: sifFlag,
          OtherPayFlag: otherPayFlag,
        })
        .then((response) => {
          setIsModelOpen(false);
  
          if (response.data != "") {
            // 👉 Redirect flow (unchanged)
            const form = document.createElement("form");
            form.action = response.data.url;
            form.method = "POST";
  
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = "PWREQUEST";
            input.value = response.data.data;
  
            form.appendChild(input);
            document.body.appendChild(form);
            form.submit();
  
            setIsCommonModelOpen(false);
          } else {
            setIsModelOpen(false);
            setIsChecked(false);
            setIsBtnDisable(true);
            setIsCommonModelOpen(false);
  
            // ❌ Toast instead of Swal
            setToast({
              type: "warning",
              message:
                "Creditor is not configured in the system. Please contact +1-855-880-4791 for assistance.",
            });
          }
        })
        .catch(() => {
          setToast({
            type: "error",
            message: "Payment failed. Please try again.",
          });
        });
    } catch (error) {
      setToast({
        type: "error",
        message: "Something went wrong. Please try again.",
      });
    }
  };



  // PAY SCHEDULE AMOUNT(PAYMENT) 
  const handleSchedulePaymentSubmit = () => {
    setIsScheduleBtnDisable(true);
  
    const itemData = {
      credenceAccountNumber: CredenceAccountNumber,
      scheduleAmount: paymentData.actualBalance,
      payImmediate: parseFloat(payImmediate) || 0.0,
      frequency: formikRef.current.values.frequency,
      startDate: convertStartDateToTimeStamp(
        formikRef.current.values.startDate
      ),
      installmentAmount: parseFloat(formikRef.current.values.totalAmount),
      convenienceFee: parseFloat(convenience),
      paymentOption: "Full",
  
      LstAmountDate: paymentSchedule.dates.map((date, index) => {
        const [year, month, day] = date.split("-").map(Number);
        const scheduledAmount = parseFloat(paymentSchedule.amounts[index]);
        const convenienceFee = parseFloat(
          paymentSchedule.convenienceList[index] || 0
        );
  
        return {
          scheduleDate: convertToTimeStamp(
            `${String(day).padStart(2, "0")}/${String(month).padStart(
              2,
              "0"
            )}/${year}`
          ),
  
          scheduledAmounts: scheduledAmount,
  
          convenienceFee: convenienceFee,
  
          totalScheduledAmount: parseFloat(
            (scheduledAmount + convenienceFee).toFixed(2)
          ),
        };
      }),
    };
  
    try {
      api
        .post(`${apiUrl}/SchedulePaymentPlan`, itemData)
        .then((response) => {
          setIsScheduleBtnDisable(false);
          setIsScheduleModelOpen(false);
          setIsScheduleChecked(false);
  
          if (response.data != "") {
            // 👉 Redirect flow (unchanged)
            const form = document.createElement("form");
            form.action = response.data.url;
            form.method = "POST";
  
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = "PWREQUEST";
            input.value = response.data.data;
  
            form.appendChild(input);
            document.body.appendChild(form);
            form.submit();
  
            setIsCommonModelOpen(false);
          } else {
            setIsScheduleBtnDisable(false);
            setIsScheduleModelOpen(false);
            setIsScheduleChecked(false);
            setIsCommonModelOpen(false);
  
            // ❌ Toast instead of Swal
            setToast({
              type: "warning",
              message:
                "Creditor is not configured in the system. Please contact +1-855-880-4791 for assistance.",
            });
          }
        })
        .catch(() => {
          setIsScheduleBtnDisable(false);
  
          setToast({
            type: "error",
            message: "Failed to schedule payment. Please try again.",
          });
        });
    } catch (err) {
      setToast({
        type: "error",
        message: "Something went wrong. Please try again.",
      });
    }
  };

  // PAY SCHEDULE AMOUNT FOR SPECIAL OFFER (PAYMENT) 
  const handleSchedulePaymentSubmitSpecialOffer = () => {
    setIsScheduleBtnDisable(true);
  
    const itemData = {
      credenceAccountNumber: CredenceAccountNumber,
      scheduleAmount: paymentData.settlementBalance,
      payImmediate: parseFloat(payImmediate) || 0.0,
      frequency:
        formikRefRemainingSpecialOffer.current.values.frequencySpecialOffer,
      startDate: convertStartDateToTimeStamp(
        formikRefRemainingSpecialOffer.current.values.startDateSpecialOffer
      ),
      installmentAmount: parseFloat(
        formikRefRemainingSpecialOffer.current.values.totalAmountSpecialOffer
      ),
      paymentOption: "Offer",
  
      LstAmountDate: paymentScheduleSpecialOffer.dates.map((date, index) => {
        const [year, month, day] = date.split("-").map(Number);
  
        const scheduledAmount = parseFloat(
          paymentScheduleSpecialOffer.amounts[index]
        );
  
        const convenienceFee = parseFloat(
          paymentScheduleSpecialOffer.convenienceList[index] || 0
        );
  
        return {
          scheduleDate: convertToTimeStamp(
            `${String(day).padStart(2, "0")}/${String(month).padStart(
              2,
              "0"
            )}/${year}`
          ),
  
          scheduledAmounts: scheduledAmount,
  
          convenienceFee: convenienceFee,
  
          totalScheduledAmount: parseFloat(
            (scheduledAmount + convenienceFee).toFixed(2)
          ),
        };
      }),
    };
  
    try {
      api
        .post(`${apiUrl}/SchedulePaymentPlan`, itemData)
        .then((response) => {
          setIsScheduleBtnDisable(false);
          setIsScheduleModelOpen(false);
          setIsScheduleChecked(false);
  
          if (response.data !== "") {
            // 👉 redirect flow unchanged
            const form = document.createElement("form");
            form.action = response.data.url;
            form.method = "POST";
  
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = "PWREQUEST";
            input.value = response.data.data;
  
            form.appendChild(input);
            document.body.appendChild(form);
            form.submit();
  
            setIsCommonModelOpen(false);
          } else {
            setIsCommonModelOpen(false);
  
            // ❌ Toast instead of Swal
            setToast({
              type: "warning",
              message:
                "Creditor is not configured in the system. Please contact +1-855-880-4791 for assistance.",
            });
          }
        })
        .catch(() => {
          setIsScheduleBtnDisable(false);
  
          setToast({
            type: "error",
            message: "Failed to schedule payment. Please try again.",
          });
        });
    } catch (err) {
      setIsScheduleBtnDisable(false);
  
      setToast({
        type: "error",
        message: "Something went wrong. Please try again.",
      });
    }
  };

  //  PAY SCHEDULE AMOUNT FOR PARTIAL PAYMENT (PAYMENT)
  const handleSchedulePaymentSubmitPartialPayment = () => {
    setIsScheduleBtnDisable(true);
  
    const newPamount = Number(
      (paymentData.actualBalance - Number(partialPaymentAmount)).toFixed(2)
    );
  
    const itemData = {
      credenceAccountNumber: CredenceAccountNumber,
      scheduleAmount: newPamount,
      payImmediate: Number(partialPaymentAmount),
      frequency:
        formikRefRemainingPartialPayment.current.values.frequencyPartialPayment,
      startDate: convertStartDateToTimeStamp(
        formikRefRemainingPartialPayment.current.values.startDatePartialPayment
      ),
      installmentAmount: parseFloat(
        formikRefRemainingPartialPayment.current.values.totalAmountPartialPayment
      ),
      paymentOption: "Other",
  
      LstAmountDate: paymentSchedulePartialPayment.dates.map((date, index) => {
        const [year, month, day] = date.split("-").map(Number);
  
        const scheduledAmount = parseFloat(
          paymentSchedulePartialPayment.amounts[index]
        );
  
        const convenienceFee = parseFloat(
          paymentSchedulePartialPayment.convenienceList[index] || 0
        );
  
        return {
          scheduleDate: convertToTimeStamp(
            `${String(day).padStart(2, "0")}/${String(month).padStart(
              2,
              "0"
            )}/${year}`
          ),
  
          scheduledAmounts: scheduledAmount,
  
          convenienceFee: convenienceFee,
  
          totalScheduledAmount: parseFloat(
            (scheduledAmount + convenienceFee).toFixed(2)
          ),
        };
      }),
    };
  
    try {
      api
        .post(`${apiUrl}/SchedulePaymentPlan`, itemData)
        .then((response) => {
          setIsScheduleBtnDisable(false);
          setIsScheduleModelOpen(false);
          setIsScheduleChecked(false);
  
          if (response.data !== "") {
            // 👉 redirect flow unchanged
            const form = document.createElement("form");
            form.action = response.data.url;
            form.method = "POST";
  
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = "PWREQUEST";
            input.value = response.data.data;
  
            form.appendChild(input);
            document.body.appendChild(form);
            form.submit();
  
            setIsCommonModelOpen(false);
          } else {
            setIsCommonModelOpen(false);
  
            // ❌ Toast instead of Swal
            setToast({
              type: "warning",
              message:
                "Creditor is not configured in the system. Please contact +1-855-880-4791 for assistance.",
            });
          }
        })
        .catch(() => {
          setIsScheduleBtnDisable(false);
  
          setToast({
            type: "error",
            message: "Failed to schedule payment. Please try again.",
          });
        });
    } catch (err) {
      setIsScheduleBtnDisable(false);
  
      setToast({
        type: "error",
        message: "Something went wrong. Please try again.",
      });
    }
  };

    const apiUrl = CONFIG.REACT_APP_API_BASE_URL;;
    useEffect(() => {
      if (paymentPlanStatus) {
        setIsError(
          "Payment plan is in progress, kindly delete the current payment plan to make further payment."
        );
      } else {
        setIsError("");
      }
  }, [paymentStatus, paymentPlanStatus]);

  useEffect(() => {
    setIsPaymentDetailsLoaded(true);
    api
      .get(`${apiUrl}/PayNow/${CredenceAccountNumber}`)
      .then((response) => {
    setIsPaymentDetailsLoaded(false);

        if (response.status === 200) {
          
          setPaymentData({
            fullBalance: response.data.actualBalance,
            actualBalance: Number(
              (
                response.data.actualBalance - response.data.paidAmount
              ).toFixed(2)
            ),
            settlementBalance: response.data.settlementBalance,
            setBalance: response.data.setBalance,
            settlementFlag: response.data.settlementFlag,
            paidAmount: response.data.paidAmount,
            otherPay: response.data.otherPay,
            specialOfferPay: response.data.specialOffer,
            payInfull: response.data.payInFull,
            specialOfferDisable: response.data.specialOfferDisable,
            planAllow : response.data.planAllow
          });
  
          dispatch(
            PaymentStatus({
              paymentPlanStatus: response.data.paymentPlanStatus,
              paymentStatus: false,
              actualBalance: response.data.actualBalance,
              merchantStatus: response.data.merchantStatus,
            })
          );
        } else {
          // ❌ Toast instead of Swal
          setToast({
            type: "error",
            message: "Something went wrong, please try again.",
          });
        }
      })
      .catch(() => {
        // Optional: handle API failure
        setToast({
          type: "error",
          message: "Failed to fetch payment details.",
        });
      });
  }, [apiUrl, paymentPlanStatus, paymentStatus]);

  const getConvenienceFee = async (amount) => {
    const response = await api.post(`${apiUrl}/PaymentFee`, {
      credenceAccountNumber: CredenceAccountNumber,
      amount: parseFloat(amount),
    });
  
    return response.data?.adjAmount || 0.0;
  };


  // GENERATE PAYMENT SCHEDULE 
  const handleSubmit = async (values) => {
    setIsLoading(true);
  
    if (paymentPlanExist) {
      setIsLoading(false);
  
      setToast({
        type: "error",
        message: "Already current plan exists.",
      });
  
      return;
    }
  
    setPaymentSchedule(null);
  
    const { frequency, startDate, totalAmount } = values;
  
    const paymentDates = generatePaymentDates(
      frequency,
      new Date(startDate),
      paymentData.actualBalance,
      totalAmount
    );
  
    const balanceRemaining = paymentData.actualBalance - totalAmount;
  
    const amounts = calculateAmounts(
      totalAmount,
      paymentDates.length,
      paymentData.actualBalance
    );
  
    try {
      const installmentCount = amounts.length;
      const lastIndex = installmentCount - 1;
  
      // 👉 Amounts
      const regularAmount = amounts[0];
      const lastAmount = amounts[lastIndex];
  
      // 👉 API calls
      const regularFee = await getConvenienceFee(regularAmount);
      const lastFee =
        regularAmount === lastAmount
          ? regularFee
          : await getConvenienceFee(lastAmount);
  
      // 👉 Build convenience fee list
      const convenienceList = Array(installmentCount).fill(regularFee);
      convenienceList[lastIndex] = lastFee;
  
      // 👉 Display schedule
      displayPaymentSchedule(
        paymentDates,
        amounts,
        balanceRemaining,
        convenienceList
      );
  
      setIsPaymentPlanVisible(true);
      setConvenience(regularFee);
      setIsLoading(false);
    } catch (error) {
      console.error("Error calculating convenience fees", error);
  
      setToast({
        type: "error",
        message: "Failed to generate payment schedule. Please try again.",
      });
  
      setIsLoading(false);
    } finally {
      setProceedBarOpen(true);
    }
  };

  const getConvenienceFeeSpecialOffer = async (amount) => {
  const response = await api.post(`${apiUrl}/PaymentFee`, {
    credenceAccountNumber: CredenceAccountNumber,
    amount: parseFloat(amount),
  });

  return response.data?.adjAmount || 0.0;
};

// GENERATE PAYMENT SCHEDULE SPECIAL OFFER
const handleSubmitSpecialOffer = async (values) => {
  setIsLoading(true);

  if (paymentPlanExistSpecialOffer) {
    setIsLoading(false);

    setToast({
      type: "error",
      message: "Already current plan exists.",
    });

    return;
  }

  setPaymentScheduleSpecialOffer(null);

  const {
    frequencySpecialOffer,
    startDateSpecialOffer,
    totalAmountSpecialOffer,
  } = values;

  const paymentDates = generatePaymentDates(
    frequencySpecialOffer,
    new Date(startDateSpecialOffer),
    paymentData.settlementBalance,
    totalAmountSpecialOffer
  );

  const amounts = calculateAmounts(
    totalAmountSpecialOffer,
    paymentDates.length,
    paymentData.settlementBalance
  );

  const balanceRemaining =
    paymentData.settlementBalance - totalAmountSpecialOffer;

  try {
    const lastIndex = amounts.length - 1;

    const regularAmount = amounts[0];
    const lastAmount = amounts[lastIndex];

    // API calls
    const regularFee = await getConvenienceFeeSpecialOffer(regularAmount);
    const lastFee =
      regularAmount === lastAmount
        ? regularFee
        : await getConvenienceFeeSpecialOffer(lastAmount);

    // Build list
    const convenienceList = Array(amounts.length).fill(regularFee);
    convenienceList[lastIndex] = lastFee;

    displayPaymentScheduleSpecialOffer(
      paymentDates,
      amounts,
      balanceRemaining,
      convenienceList
    );

    setConvenienceSpecialOffer(regularFee);
    setIsPaymentPlanVisibleSpecialOffer(true);
    setIsLoading(false);
  } catch (error) {
    console.error("Special Offer convenience fee error", error);

    setToast({
      type: "error",
      message: "Failed to generate special offer payment plan. Please try again.",
    });

    setIsLoading(false);
  } finally {
    setProceedBarOpen(true);
  }
};

const getConvenienceFeePartialPayment = async (amount) => {
  const response = await api.post(`${apiUrl}/PaymentFee`, {
    credenceAccountNumber: CredenceAccountNumber,
    amount: parseFloat(amount),
  });

  return response.data?.adjAmount || 0.0;
};

// GENERATE PAYMENT SCHEDULE PARTIAL AMOUNT
const handleSubmitPartialPayment = async (values) => {
  setIsLoading(true);

  if (partialPaymentAmount < 0.01) {
    setIsLoading(false);

    setToast({
      type: "error",
      message: "Please enter a valid partial payment amount first.",
    });

    return;
  }

  if (paymentPlanExistPartialPayment) {
    setIsLoading(false);

    setToast({
      type: "error",
      message: "Already current plan exists.",
    });

    return;
  }

  setPaymentSchedulePartialPayment(null);

  const {
    frequencyPartialPayment,
    startDatePartialPayment,
    totalAmountPartialPayment,
  } = values;

  const newPamount = Number(
    (paymentData.actualBalance - Number(partialPaymentAmount)).toFixed(2)
  );

  const paymentDates = generatePaymentDates(
    frequencyPartialPayment,
    new Date(startDatePartialPayment),
    newPamount,
    totalAmountPartialPayment
  );

  const amounts = calculateAmounts(
    totalAmountPartialPayment,
    paymentDates.length,
    newPamount
  );

  const balanceRemaining = newPamount - totalAmountPartialPayment;

  try {
    const lastIndex = amounts.length - 1;

    const regularAmount = amounts[0];
    const lastAmount = amounts[lastIndex];

    const regularFee = await getConvenienceFeePartialPayment(regularAmount);
    const lastFee =
      regularAmount === lastAmount
        ? regularFee
        : await getConvenienceFeePartialPayment(lastAmount);

    const convenienceList = Array(amounts.length).fill(regularFee);
    convenienceList[lastIndex] = lastFee;

    displayPaymentSchedulePartialPayment(
      paymentDates,
      amounts,
      balanceRemaining,
      convenienceList
    );

    setConveniencePartialPayment(regularFee);
    setIsPaymentPlanVisiblePartialPayment(true);
    setIsLoading(false);
  } catch (error) {
    console.error("Partial payment convenience fee error", error);

    setToast({
      type: "error",
      message: "Failed to generate partial payment plan. Please try again.",
    });

    setIsLoading(false);
  } finally {
    setProceedBarOpen(true);
  }
};

  const generatePaymentDates = (
    frequency,
    startDate,
    actualBalance,
    totalAmount
  ) => {
    const formatDate = (d) => {
      return new Date(d).toLocaleDateString("en-CA"); // Returns date as 'YYYY-MM-DD'
    };
    const dates = [];

    let date = parseLocalDate(startDate);

    if (actualBalance % totalAmount == 0) {
      switch (frequency) {
        case "Weekly":
          for (let i = 0; i < Math.floor(actualBalance / totalAmount); i++) {
            dates.push(formatDate(date));

            date.setDate(date.getDate() + 7);
          }
          break;
        case "BiWeekly":
          for (let i = 0; i < Math.floor(actualBalance / totalAmount); i++) {
            dates.push(formatDate(date));

            date.setDate(date.getDate() + 14);
          }
          break;
        case "Monthly":
          for (let i = 0; i < Math.floor(actualBalance / totalAmount); i++) {
            dates.push(formatDate(date));

            date.setMonth(date.getMonth() + 1);
          }
          break;
        case "Quaterly":
          for (let i = 0; i < Math.floor(actualBalance / totalAmount); i++) {
            dates.push(formatDate(date));

            date.setMonth(date.getMonth() + 3);
          }
          break;
        case "Onetime":
          dates.push(formatDate(date));

          break;
        default:
          alert("Please choose frequency.");
          return;
      }
    } else {
      switch (frequency) {
        case "Weekly":
          for (let i = 0; i <= Math.floor(actualBalance / totalAmount); i++) {
            dates.push(formatDate(date));
            date.setDate(date.getDate() + 7);
          }
          break;
        case "BiWeekly":
          for (let i = 0; i <= Math.floor(actualBalance / totalAmount); i++) {
            dates.push(formatDate(date));
            date.setDate(date.getDate() + 14);
          }
          break;
        case "Monthly":
          for (let i = 0; i <= Math.floor(actualBalance / totalAmount); i++) {
            dates.push(formatDate(date));
            date.setMonth(date.getMonth() + 1);
          }
          break;
        case "Quaterly":
          for (let i = 0; i <= Math.floor(actualBalance / totalAmount); i++) {
            dates.push(formatDate(date));
            date.setMonth(date.getMonth() + 3);
          }
          break;
        case "Onetime":
          dates.push(formatDate(date));
          break;
        default:
          alert("Please choose frequency.");
          return;
          break;
      }
    }

    return dates;
  };

  const [frequency, setFrequency] = useState("");
  const [startDate, setStartDate] = useState("");
  const [installmentAmount, setInstallmentAmount] = useState("");

  const calculateAmounts = (totalAmount, numPayments, actualBalance) => {
    let amountsNew = [];
    let newActualBalance = +actualBalance;
    let newTotalAmount = +totalAmount;
    for (let i = 1; i <= numPayments; i++) {
      if (newTotalAmount < newActualBalance) {
        amountsNew.push(newTotalAmount.toFixed(2));
      } else {
        amountsNew.push(newActualBalance.toFixed(2));
      }
      newActualBalance = newActualBalance - newTotalAmount;

    }
    return amountsNew;
  };

  const displayPaymentSchedule = (dates, amounts, newAmount, convenienceList) => {
    setPaymentSchedule({
      dates,
      amounts,
      newAmount,
      convenienceList
    });
  };

  const displayPaymentScheduleSpecialOffer = (dates, amounts, newAmount, convenienceList) => {
    setPaymentScheduleSpecialOffer({
      dates,
      amounts,
      convenienceList,
      newAmount,
    });
  };

  const displayPaymentSchedulePartialPayment = (dates, amounts, newAmount, convenienceList) => {
    setPaymentSchedulePartialPayment({
      dates,
      amounts,
      newAmount,
      convenienceList
    });
  };


  const parseLocalDate = (input) => {
    // Ensure it's a string in YYYY-MM-DD format
    // console.log(input)
    const dateStr =
      typeof input === "string" ? input : input.toISOString().split("T")[0]; // fallback if it's a Date object

    const [year, month, day] = dateStr.split("-").map(Number);
    return new Date(year, month - 1, day); // JS months are 0-based
  };

  const [isPaymentPlanVisible, setIsPaymentPlanVisible] = useState(false);
  const [isPaymentPlanVisibleSpecialOffer, setIsPaymentPlanVisibleSpecialOffer] = useState(false);
  const [isPaymentPlanVisiblePartialPayment, setIsPaymentPlanVisiblePartialPayment] = useState(false);
  const [paymentFormVisible, setPaymentFormVisible] = useState(false);
  const [paymentFormVisibleSpecialOffer, setPaymentFormVisibleSpecialOffer] = useState(false);
  const [paymentFormVisiblePartialPayment, setPaymentFormVisiblePartialPayment] = useState(false);
  const [externalFrequencyValue, setExternalFrequencyValue] = useState(null);
  const [externalStateFrequencyValueSpecialOffer, setExternalFrequencyValueSpecialOffer] = useState(null);
  const [externalStateFrequencyValuePartialPayment, setExternalFrequencyValuePartialPayment] = useState(null);


  const initialValues = {
    frequency: "",
    startDate: "",
    installmentAmount: "",
  };

  const formatLocalDate = (yyyyMmDd) => {
    const [year, month, day] = yyyyMmDd.split("-").map(Number);
    return new Date(year, month - 1, day).toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };


  //  Formik validation for normal installment payment
  const validationSchema = Yup.object({
    totalAmount: Yup.number()
      .required("Total amount is required")
      .min(
        Math.ceil(minRequiredAmount),
        `Minimum installment amount can be ${Math.ceil(
          minRequiredAmount
        )} for ${externalFrequencyValue}`
      )
      .max(
        Math.ceil(
          paymentData.actualBalance - payImmediate
        ),
        `maximum amount can be ${Math.ceil(
          paymentData.actualBalance - payImmediate
        )} `
      )
      .test(
        "no-invalid-chars",
        "Values less than 0 and special characters are not allowed",
        (value) => {
          if (typeof value === "string") {
            const invalidChars = ["-", "+", "e", ".", ",", "E", "0"];

            return !invalidChars.some((char) => value.includes(char));
          }
          return true;
        }
      ),
    frequency: Yup.string().required("Payment frequency is required"),
    startDate: Yup.date().required("Start date is required"),
  });
   
   //  Formik validation for offer installment payment
  const validationSchemaSpecialOffer = Yup.object({
    totalAmountSpecialOffer: Yup.number()
      .required("Total amount is required")
      .min(
        Math.ceil(minRequiredAmountSpecialOffer),
        `Minimum installment amount can be ${Math.ceil(
          minRequiredAmountSpecialOffer
        )} for ${externalStateFrequencyValueSpecialOffer}`
      )
      .max(
        Math.ceil(
          paymentData.settlementBalance - payImmediate
        ),
        `maximum amount can be ${Math.ceil(
          paymentData.settlementBalance - payImmediate
        )} `
      )
      .test(
        "no-invalid-chars",
        "Values less than 0 and special characters are not allowed",
        (value) => {
          if (typeof value === "string") {
            const invalidChars = ["-", "+", "e", ".", ",", "E", "0"];

            return !invalidChars.some((char) => value.includes(char));
          }
          return true;
        }
      ),
    frequencySpecialOffer: Yup.string().required("Payment frequency is required"),
    startDateSpecialOffer: Yup.date().required("Start date is required"),
  });

  //  Formik validation for partial installment payment
  const validationSchemaPartialPayment = Yup.object({
    totalAmountPartialPayment: Yup.number()
      .required("Total amount is required")
      .min(
        Math.ceil(minRequiredAmountPartialPayment),
        `Minimum installment amount can be ${Math.ceil(
          minRequiredAmountPartialPayment
        )} for ${externalStateFrequencyValuePartialPayment}`
      )
      .max(
        Math.ceil(
          Number((paymentData.actualBalance - Number(partialPaymentAmount)).toFixed(2)) - payImmediate
        ),
        `maximum amount can be ${Math.ceil(
          Number((paymentData.actualBalance - Number(partialPaymentAmount)).toFixed(2)) - payImmediate
        )} `
      )
      .test(
        "no-invalid-chars",
        "Values less than 0 and special characters are not allowed",
        (value) => {
          if (typeof value === "string") {
            const invalidChars = ["-", "+", "e", ".", ",", "E", "0"];

            return !invalidChars.some((char) => value.includes(char));
          }
          return true;
        }
      ),
    frequencyPartialPayment: Yup.string().required("Payment frequency is required"),
    startDatePartialPayment: Yup.date().required("Start date is required"),
  });

  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  
  
  const handlePayments = () => {
    setIsProcessingPayment(true);
    if (specialOffer) {
      if (showRemainingInstallment && isPaymentPlanVisibleSpecialOffer) {
        handleSchedulePaymentSubmitSpecialOffer()
      } else {
        handlePayment()
      }
    }
    else if (payFull) {
      handlePayment()
    }
    else if (Installment) {
      handleSchedulePaymentSubmit();
    }
    else if (partial) {
      if (partialPaymentAmount < 0.01) {
        alert("Please enter a valid partial payment amount first.");
        return
      }
      if (showRemainingInstallmentPartialPayment && isPaymentPlanVisiblePartialPayment) {
        handleSchedulePaymentSubmitPartialPayment()
      } else {
        handlePayment()
      }
    }
  }

 /* State Section */
  const [showModal, setShowModal] = useState(false);
  const [selectedState, setSelectedState] = useState("");
  const [stateList, setStateList] = useState([]);
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const res = await api.get(`${apiUrl}/State`);
        if (res?.data) {
         // console.log(res);
          setStateList(res.data); 
          if (res.data.length > 0) {
            setShowModal(true); 
          }
        }
      } catch (err) {
       // console.error("State API error", err);
        // Optional: handle 401 specifically to avoid logout
        // if (err.response?.status === 401) {
        //   console.warn("Unauthorized! Don't auto logout in this modal fetch.");
        // }
      }
    };

    fetchStates();
  }, [apiUrl]);

  // useEffect(() => {
  //   api
  //     .get(`${apiUrl}/CustomerInformation/${CredenceAccountNumber}`)
  //     .then((response) => {
  //       if (response.status === 200) {
  //         setSelectedState(response.data.webState);
  //       } else {
  //       }
  //     })
  //     .catch((error) => {});
  // }, [CredenceAccountNumber, apiUrl]);

  const handleStateUpdate = () => {
    const data = {
      credenceAccountNumber: CredenceAccountNumber,
      stateCode: selectedState,
    };
  
    api
      .put(`${apiUrl}/State`, data)
      .then((response) => {
        if (response.status === 200) {
          setShowModal(false);
  
          // ✅ Success toast
          setToast({
            type: "success",
            message: "State updated successfully.",
          });
        } else {
          // ❌ Error toast
          setToast({
            type: "error",
            message: "Something went wrong while updating the state.",
          });
        }
      })
      .catch(() => {
        setToast({
          type: "error",
          message: "Something went wrong while updating the state.",
        });
      });
  };

  
useEffect(() => {
  document.body.style.overflow = isCommonModelOpen ? "hidden" : "auto";

  return () => {
    document.body.style.overflow = "auto";
  };
}, [isCommonModelOpen]);

useEffect(() => {
  document.body.style.overflow = showModal ? "hidden" : "auto";

  return () => {
    document.body.style.overflow = "auto";
  };
}, [showModal]);


const [ isLoading , setIsLoading] = useState(false);
const [ isPaymentDetailsLoaded , setIsPaymentDetailsLoaded] = useState(false);


useEffect(() => {
  if (!isCommonModelOpen) {
    setIsAgreed(false);
  }
}, [isCommonModelOpen]);

  return (
    <>
    {toast && (
  <Toast
    message={toast.message}
    type={toast.type}
    onClose={() => setToast(null)}
  />
)}
    {/* <div className="app-shell-with-header"> */}
       
      
        {/* <!-- MAIN CONTENT --> */}
        <main className="main-content">
{ isPaymentDetailsLoaded ? <PaymentDashboardSkeleton/> : (
          <div className="layout-container">
             <div className="layout-page">

             {paymentPlanStatus || paymentStatus ? 
              <>
              {/* PAYMENT PLAN IN PROGRESS   */}
              <section className="empty-state-section" id="paymentInprogressState" >
                <div className="general-card empty-state-card">
                    <div className="empty-state-content">
                        <div className="empty-state-icon">
                            <i className='bx bxs-hourglass'></i>
                        </div>
                        <h3 className="empty-state-title text-balance">
  {paymentPlanStatus ? "Payment Plan in Progress" : ""}
</h3>
                        <p className="empty-state-text text-balance">{isError}</p>
                    </div>
                </div>
            </section> 
              </> : (<>
            {/* <!-- GREETING SECTION --> */}
            <section className="greeting-section">
                <div className="greeting-content">
                 
                  <h1 className="greeting-name mb-1">Hi <span aria-hidden="true">👋</span> {AccountInfo.firstName}</h1>
                  
                    <h2 className="greeting-subtitle mb-0">Manage your Credence account</h2>
                </div>
              </section>

              {/* <!-- SINGLE ACCOUNT BALANCE CARD --> */}
              <section className="summary-section">
                <div className="general-card balance-hero-card">
                  <div className="balance-hero-content">
                    <div className="balance-hero-left">
                      <p className="balance-label text-balance">Balance</p>
                      <h2 className="payments-balance-amount mb-0">${paymentData.fullBalance ? (paymentData.fullBalance).toFixed(2) : "0.00"}</h2>
                      <span style={{color:"#800020"}}>*The balance does not reflect recently processed payments.</span>
                    </div>

                    <div className="balance-hero-right">
  <div className="ac-stat-item">
    <span className="stat-label">Credence Account Number</span>
    <div className="stat-value account-num">
      {CredenceAccountNumber
        ? `${CredenceAccountNumber.slice(0, 2)}***${CredenceAccountNumber.slice(-3)}`
        : ""}
    </div>
  </div>
</div>
                  </div>

                  <div className="rights-link-section mt-3">
                    {customerRights.length > 0 ? <Link
  to="/profile"
  state={{ scrollTo: "prefernceItems" }}
  className="xsmall"
>
  Your Rights
</Link> : <></>}
                  
                  </div>
                </div>
              </section>

              {/* <!-- TOTAL BALANCE CARD --> */}
              <section className="summary-section" style={{ display: "none" }}>
                <div className="general-card balance-hero-card">
                  <div className="balance-hero-content">
                    <div className="balance-hero-left">
                      <p className="balance-label mb-3 text-balance">
                        Total Balance Across All Accounts
                      </p>
                      <h2 className="payments-balance-amount mb-0">$505.50</h2>
                    </div>

                    <div className="balance-hero-right">
                      <span className="account-badge">
                        <span className="badge-dot"></span>
                        4 Active Accounts
                      </span>
                    </div>
                  </div>
                </div>
              </section>


              {/* <!-- ACCOUNTS SELECTION SECTION --> */}
              <section className="account-section" style={{ display: "none" }}>
                <div className="general-card account-card">

                  {/* Card Header */}
                  <div className="account-card-header">
                    <div>
                      <h3 className="account-card-title mb-1">Your Credence Accounts</h3>
                      <p className="account-card-subtitle text-balance mb-0">
                        Select accounts you'd like to make a payment for
                      </p>
                    </div>
                  </div>

                  {/* Account Table */}
                  <div className="account-table-wrapper">
                    <table
                      id="LinkedAccountTable"
                      className="table account-selection-table"
                    >
                      <thead>
                        <tr>
                          <th>Account Number</th>
                          <th className="text-end">Current Balance</th>
                          <th
                            className="text-center justify-item-center"
                            style={{ width: 100 }}
                          >
                            <button
                              id="btnSelectAll"
                              className="btn-select-all"
                              title="Select All"
                            >
                              <i className="bx bx-list-check"></i>
                            </button>
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr className="account-row">
                          <td>
                            <span className="account-number">32***147</span>
                          </td>
                          <td className="text-end">
                            <span className="account-balance" id="amt1">$100</span>
                          </td>
                          <td className="text-center">
                            <div className="checkbox-wrapper">
                              <input
                                id="chkAccount1"
                                className="form-check-input account-checkbox"
                                type="checkbox"
                                defaultChecked
                              />
                            </div>
                          </td>
                        </tr>

                        <tr className="account-row account-row-alt">
                          <td>
                            <span className="account-number">32***148</span>
                          </td>
                          <td className="text-end">
                            <span className="account-balance" id="amt2">$150</span>
                          </td>
                          <td className="text-center">
                            <div className="checkbox-wrapper">
                              <input
                                id="chkAccount2"
                                className="form-check-input account-checkbox"
                                type="checkbox"
                                defaultChecked
                              />
                            </div>
                          </td>
                        </tr>

                        <tr className="account-row">
                          <td>
                            <span className="account-number">32***149</span>
                          </td>
                          <td className="text-end">
                            <span className="account-balance" id="amt3">$50</span>
                          </td>
                          <td className="text-center">
                            <div className="checkbox-wrapper">
                              <input
                                id="chkAccount3"
                                className="form-check-input account-checkbox"
                                type="checkbox"
                                defaultChecked
                              />
                            </div>
                          </td>
                        </tr>

                        <tr className="account-row account-row-alt">
                          <td>
                            <span className="account-number">32***150</span>
                          </td>
                          <td className="text-end">
                            <span className="account-balance" id="amt4">$200</span>
                          </td>
                          <td className="text-center">
                            <div className="checkbox-wrapper">
                              <input
                                id="chkAccount4"
                                className="form-check-input account-checkbox"
                                type="checkbox"
                                defaultChecked
                              />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* Selected Total Bar */}
                  <div className="selected-total-bar">
                    <div className="selected-total-content">
                      <div className="selected-total-left">
                        <p className="selected-total-label mb-1">
                          Total for Selected Accounts
                        </p>
                        <h5
                          className="selected-total-amount mb-3"
                          id="totalSelectedAmount"
                        >
                          $505.50
                        </h5>
                        <p
                          className="selected-accounts-note"
                          id="offerEligibilityNote"
                        >
                          <i className="bx bx-gift"></i>{" "}
                          Select all 4 accounts to unlock special offer
                        </p>
                      </div>

                      <div className="selected-total-right">
                        <button className="btn btn-continue">
                          Continue to Payment
                        </button>
                      </div>
                    </div>
                  </div>

                </div>
              </section>
              

              
              
              {
  paymentData.actualBalance
    ? !(
        String(paymentData.actualBalance) === '0' ||
        String(paymentData.actualBalance) === '0.00' ||
        String(paymentData.actualBalance) === '0.0000' ||
        paymentData.actualBalance === 0 ||
        paymentData.specialOfferPay ||
        paymentData.payInFull ||
        (Number(paymentData.actualBalance) - Number(paymentData.paidAmount) === 0)
      ) && (
        <section className="payment-plan-section">
                <div className="general-card payment-plan-card">

                  {/* Section Header */}
                  {paymentPlanStatus || paymentStatus ? "" : <div className="payment-plan-header">
                    <h3 className="payment-plan-title text-balance">
                      Choose Your Payment Plan
                    </h3>
                    {/* <p className="payment-plan-subtitle text-balance">
                      Select how you'd like to pay for the selected accounts
                    </p> */}
                  </div>}
                    {/* { isError ? <div className="offer-banner-section">
                    <div className="offer-banner-card">
                      <h5 className="paragraph-xs mb-0 text-balance">{isError}</h5>
                    </div>
                  </div> : ""} */}
                  {AccountInfo.setCount > 1  ? <div className="offer-banner-section">
                    <div className="offer-banner-card">
                      <h5 className="paragraph-xs mb-0 text-balance">For special offers or to set up an arrangement, please call +1-855-880-4791</h5>
                    </div>
                  </div> : ""}
                  {/* Payment Plan Options */}
                  <div className="payment-plan-options">

                    {/* Special Offer */}
                    {AccountInfo.setCount > 1 || paymentPlanStatus || paymentStatus || paymentData.settlementFlag == 0 || paymentData.otherPay || paymentData.specialOfferDisable ? "" :
                      <div className="plan-option" data-plan="special-offer" onClick={() => {
                        handleOfferPaymentSubmit(); setProceedBarOpen(true); setSpecialOffer(true); setPayFull(false); setInstallment(false); setPartial(false); setShowInstallment(false); setShowPartial(false); setShowRemainingInstallment(false); setPaymentFormVisible(false); setShowRemainingInstallmentPartialPayment(false); setIsPaymentPlanVisible(false);setIsPaymentPlanVisibleSpecialOffer(false);setIsPaymentPlanVisiblePartialPayment(false);setPaymentFormVisibleSpecialOffer(true); setPaymentFormVisiblePartialPayment(false); formikRef?.current?.resetForm(); formikRefRemainingSpecialOffer?.current?.resetForm(); formikRefRemainingPartialPayment?.current?.resetForm(); SetInstallmentAmountErrorMessage(""); SetInstallmentAmountErrorMessageSpecialOffer(""); SetInstallmentAmountErrorMessagePartialPayment(""); window.scrollTo({
                          top: document.body.scrollHeight,
                          behavior: "smooth",
                        }); setPartialPaymentAmount(0)
                      }}>
                        <input
                          type="radio"
                          id="plan-special"
                          name="paymentPlan"
                          value="special-offer"
                          className="plan-radio"
                        />
                        <label htmlFor="plan-special" className="plan-label">
                          <div className="plan-header">
                            <div className="plan-icon special-offer-icon">
                              <i className="bx bx-gift"></i>
                            </div>
                            <div className="plan-info">
                              <h3 className="plan-name">Special Offer</h3>
                              <p className="plan-description" style={{ display: "block" }}>
                                Pay ${paymentData.settlementBalance ? paymentData.settlementBalance.toFixed(2) : ""} and save ${(paymentData.fullBalance - paymentData.settlementBalance).toFixed(2)}
                              </p>
                            </div>
                          </div>
                        </label>
                      </div>}

                    {/* Pay in Full */}
                    {paymentPlanStatus || paymentStatus  ? "" : <div className="plan-option" data-plan="pay-full" onClick={() => {
                      handlePaymentSubmit(); setProceedBarOpen(true); setPayFull(true); setSpecialOffer(false); setInstallment(false); setPartial(false); setShowInstallment(false); setShowPartial(false); setShowRemainingInstallment(false); setPaymentFormVisible(false); setShowRemainingInstallmentPartialPayment(false); setIsPaymentPlanVisible(false);setIsPaymentPlanVisibleSpecialOffer(false);setIsPaymentPlanVisiblePartialPayment(false); setPaymentFormVisibleSpecialOffer(false); setPaymentFormVisiblePartialPayment(false); formikRef?.current?.resetForm(); formikRefRemainingSpecialOffer?.current?.resetForm(); formikRefRemainingPartialPayment?.current?.resetForm(); SetInstallmentAmountErrorMessage(""); SetInstallmentAmountErrorMessageSpecialOffer(""); SetInstallmentAmountErrorMessagePartialPayment(""); window.scrollTo({
                        top: document.body.scrollHeight,
                        behavior: "smooth",
                      }); setPartialPaymentAmount(0)
                    }}>
                      <input
                        type="radio"
                        id="plan-full"
                        name="paymentPlan"
                        value="pay-full"
                        className="plan-radio"
                      />
                      <label htmlFor="plan-full" className="plan-label">
                        <div className="plan-header">
                          <div className="plan-icon full-payment-icon">
                            <i className="bx bx-credit-card"></i>
                          </div>
                          <div className="plan-info">
                            <h3 className="plan-name">Pay in Full</h3>
                            <p className="plan-description">
                              Complete payment for all selected accounts
                            </p>
                          </div>
                        </div>
                      </label>
                    </div>}

                    {/* Installment */}
                    {AccountInfo.setCount > 1  || paymentPlanStatus || paymentStatus || !paymentData.planAllow ?  "" : <div className="plan-option" data-plan="installment" onClick={() => {
                      setProceedBarOpen(false); setPayFull(false); setSpecialOffer(false); setInstallment(true); setPartial(false); setShowInstallment(true); setShowPartial(false); setShowRemainingInstallment(false); setPaymentFormVisible(true); setShowRemainingInstallmentPartialPayment(false); setIsPaymentPlanVisible(false);setIsPaymentPlanVisibleSpecialOffer(false);setIsPaymentPlanVisiblePartialPayment(false); setPaymentFormVisibleSpecialOffer(false); setPaymentFormVisiblePartialPayment(false); formikRef?.current?.resetForm(); formikRefRemainingSpecialOffer?.current?.resetForm(); formikRefRemainingPartialPayment?.current?.resetForm(); SetInstallmentAmountErrorMessage(""); SetInstallmentAmountErrorMessageSpecialOffer(""); SetInstallmentAmountErrorMessagePartialPayment(""); 
                      window.scrollTo({
                        top: document.body.scrollHeight,
                        behavior: "smooth",
                      }); setPartialPaymentAmount(0)
                    }}>
                      <input
                        type="radio"
                        id="plan-installment"
                        name="paymentPlan"
                        value="installment"
                        className="plan-radio"
                      />
                      <label htmlFor="plan-installment" className="plan-label">
                        <div className="plan-header">
                          <div className="plan-icon installment-icon">
                            <i className="bx bx-calendar"></i>
                          </div>
                          <div className="plan-info">
                            <h3 className="plan-name">Payment Arrangement</h3>
                            <p className="plan-description">
                              Set up installment payments over time
                            </p>
                          </div>
                        </div>
                      </label>
                    </div>}

                    {/* Partial */}
                    {paymentPlanStatus || paymentStatus ? "" : <div className="plan-option" data-plan="partial" onClick={() => {
                      handlePartialPaymentSubmit(); setProceedBarOpen(true); setPartial(true); setPayFull(false); setSpecialOffer(false); 
                      setInstallment(false); setShowPartial(true); setShowInstallment(false); setShowRemainingInstallment(false); 
                      setShowRemainingInstallmentPartialPayment(false); setPaymentFormVisible(false); setIsPaymentPlanVisible(false);
                      setIsPaymentPlanVisibleSpecialOffer(false);setIsPaymentPlanVisiblePartialPayment(false); setPaymentFormVisibleSpecialOffer(false); 
                      setPaymentFormVisiblePartialPayment(true); formikRef?.current?.resetForm(); formikRefRemainingSpecialOffer?.current?.resetForm();
                       formikRefRemainingPartialPayment?.current?.resetForm(); SetInstallmentAmountErrorMessage(""); SetInstallmentAmountErrorMessageSpecialOffer(""); 
                       SetInstallmentAmountErrorMessagePartialPayment(""); 
                       window.scrollTo({
                         top: document.getElementById("partialConfig")?.offsetTop,
                         behavior: "smooth",
                         
                       });
                    }}>
                      <input
                        type="radio"
                        id="plan-partial"
                        name="paymentPlan"
                        value="partial"
                        className="plan-radio"
                      />
                      <label htmlFor="plan-partial" className="plan-label">
                        <div className="plan-header">
                          <div className="plan-icon partial-icon">
                            <i className="bx bx-wallet"></i>
                          </div>
                          <div className="plan-info">
                            <h3 className="plan-name">Pay What You Can Today</h3>
                            <p className="plan-description">
                              Make a partial payment now
                            </p>
                          </div>
                        </div>
                      </label>
                    </div>
}
                  </div>
                  {/* <!-- special offer summary --> */}
                  {specialOffer && !showRemainingInstallment && (<div className="special-offer-installment" id="specialOfferConfig">
                    <div className="d-flex justify-content-center" id="">
                      <p className="xxsmall fw-m">We are not obligated to renew this offer</p>
                    </div>

                    <div className="special-offer-summary mt-3" id="specialOfferSummaryChart">
                      <div className="special-offer-summary-row">
                        <div className="special-offer-summary-label">Offer Amount: </div>
                        <div className="special-offer-summary-value">${paymentData.settlementBalance.toFixed(2)}</div>
                      </div>
                      <div className="special-offer-summary-row">
                        <div className="special-offer-summary-label">Convenience Fee*: </div>
                        <div className="special-offer-summary-value">${Number(convenienceFeeSpecialOffer || 0).toFixed(2)}</div>
                      </div>
                      <div className="special-offer-summary-row">
                        <div className="special-offer-summary-label">Total Payment Amount: </div>
                        <div className="special-offer-summary-value">${(Number(paymentData.settlementBalance) + Number(convenienceFeeSpecialOffer) + 0).toFixed(2)}</div>
                      </div>
                    </div>
                      <div className="ach-disclaimer-wrapper">
                                <div className="ach-disclaimer-content">
                                    <p className="xxsmall fw-m">*Applies to card payments only. Select E-Check for a free payment option.</p>
                                </div>
                            </div>
                  </div>)}


                  {/* Special Offer Toggle */}
                  {(specialOffer && paymentData.planAllow) && (
                    <div className="special-offer-installment" id="specialOfferConfig">
                      <div className="special-offer-installment-wrapper">
                        <p className="config-subtitle text-balance">
                          Would you like to schedule plan for Special offer
                        </p>

                        <label className="custom-toggle-switch">
                          <input
                            type="checkbox"
                            className="custom-toggle-switch__input"
                            id="scheduleOfferYes"
                            checked={showRemainingInstallment}
                            role="checkbox"
                            aria-checked="false"
                            aria-label="Schedule plan for Special Offer"
                            onChange={(e) => {
    const isChecked = e.target.checked;

    setShowRemainingInstallment(isChecked);
    setProceedBarOpen(!isChecked);
  }}
                          />
                          <span className="custom-toggle-switch__slider"></span>
                        </label>
                      </div>
                    </div>
                  )}

                  {payFull && (<div className="payinfull-summary-wrapper" id="payinfullSummaryConfig">
                    <div className="payinfull-summary">
                      <div className="payinfull-summary-row">
                        <div className="payinfull-summary-label">Full Amount: </div>
                        <div className="payinfull-summary-value">${paymentData.actualBalance.toFixed(2)}</div>
                      </div>
                      <div className="payinfull-summary-row">
                        <div className="payinfull-summary-label">Convenience Fee*: </div>
                        <div className="payinfull-summary-value">${Number(convenienceFee || 0).toFixed(2)}</div>
                      </div>
                      <div className="payinfull-summary-row">
                        <div className="payinfull-summary-label">Total Payment Amount:  </div>
                        <div className="payinfull-summary-value">${(Number(paymentData.actualBalance) + Number(convenienceFee) + 0).toFixed(2)}</div>
                      </div>
                    </div>
                    <div className="ach-disclaimer-wrapper">
                            <div className="ach-disclaimer-content">
                                <p className="xxsmall fw-m">*Applies to card payments only. Select E-Check for a free payment option.</p>
                            </div>
                        </div>
                  </div>)}

                  {/* Installment Configuration (Hidden by default, shown when installment selected) */}
                  {showInstallment && (
                    <div className="installment-config" id="installmentConfig">

                      <div className="config-header">
                        <h4 className="config-title text-balance">Configure Your Payment Schedule</h4>
                        <p className="config-subtitle text-balance">Set up your installment plan below</p>
                      </div>


                      {/* Installment form for normal payment schedule */}
                      <Formik
                        innerRef={formikRef}
                        initialValues={{
                          frequency: "",
                          startDate: "",
                          totalAmount: externalStateTotalAmount,
                        }}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                      >
                        {({ setFieldValue, values }) => {
                          return (
                            <Form
                              id="paymentForm"
                              className=" "
                              style={{ display: paymentFormVisible ? "" : "none" }}
                            >
                              <div className="config-form">
                                <div className="config-row">
                                  <div className="config-field">
                                    <label htmlFor="frequency" className="field-label">
                                      Payment Frequency
                                      <span className="required">*</span>
                                    </label>
                                    <Field
                                      as="select"
                                      name="frequency"
                                      className="field-input"
                                      ref={frequencyRef}
                                      onChange={(e) => {
                                        const selectedFrequency = e.target.value;
                                        setFieldValue("frequency", selectedFrequency);
                                        setExternalFrequencyValue(e.target.value);
                                       // console.log("freq", e.target.value)

                                        if (selectedFrequency === "Onetime") {
                                          SetInstallmentAmountErrorMessage("");

                                          setFieldValue(
                                            "totalAmount",
                                            paymentData.actualBalance
                                          );
                                        } else {
                                          setFieldValue("totalAmount", "");
                                          let numInstallments = 1;

                                          const getAllowedInstallments = () => {
                                            switch (e.target.value) {
                                              case "Weekly":
                                                return 26;
                                              case "BiWeekly":
                                                return 13;
                                              case "Monthly":
                                                return 6;
                                              case "Quaterly":
                                                return 2;
                                              case "Onetime":
                                                return 1;
                                              default:
                                                return 6;
                                            }
                                          };

                                          const allowedInstallments =
                                            getAllowedInstallments();

                                          if (allowedInstallments > 1) {
                                            const minRequired = paymentData.actualBalance / allowedInstallments;

                                            setMinRequiredAmount(minRequired);

                                            if (
                                              e.target.value !== "Onetime" &&
                                              e.target.value !== "Choose frequency"
                                            ) {
                                              SetInstallmentAmountErrorMessage(
                                                `Minimum installment amount can be $ ${Math.ceil(
                                                  minRequired
                                                )} for ${e.target.value}`
                                              );
                                            } else {
                                              SetInstallmentAmountErrorMessage("");
                                            }
                                          }
                                         // console.log("minRequiredAmount", minRequiredAmount)
                                        }
                                      }}
                                    >
                                      <option value={null}>Choose frequency</option>
                                      <option value="Onetime">One Time</option>
                                      <option value="Weekly">Weekly</option>
                                      <option value="BiWeekly">Bi-Weekly</option>
                                      <option value="Monthly">Monthly</option>
                                      <option value="Quaterly">Quarterly</option>
                                    </Field>
                                    <div className="Error-msg">
                                      <ErrorMessage
                                        name="frequency"
                                        component="span"
                                        className="text-danger"
                                      />
                                    </div>
                                  </div>
                                  <div className="config-field">
                                    <label htmlFor="startDate" className="field-label">
                                      Start Date<span className="required">*</span>
                                    </label>

                                    <Field
                                      type="date"
                                      name="startDate"
                                      format="MM/dd/yyyy"
                                      className="field-input"
                                      min={
                                        isPayNowAndScheduleChecked
                                          ? new Date(Date.now() + 86400000) // adds 1 day in milliseconds
                                            .toLocaleDateString("en-CA") // formats to 'YYYY-MM-DD'
                                          : new Date().toLocaleDateString("en-CA") // current date in local time
                                      }
                                      max={
                                        new Date(
                                          Date.now() + 25 * 86400000
                                        ).toLocaleDateString("en-CA") // formats to 'YYYY-MM-DD'
                                      }
                                      onBlur={(e) => {
                                        const value = e.target.value;
                                        const year = value.split("-")[0];
                                        if (year.length > 4 || year.length < 4) {
                                          alert("Invalid Date");
                                        }
                                      }}
                                    />

                                    <div className="Error-msg">
                                      <ErrorMessage
                                        name="startDate"
                                        component="span"
                                        className="text-danger"
                                      />
                                    </div>
                                  </div>


                                </div>
                                <div className="config-row">
                                  <div className="config-field">
                                    <label htmlFor="installmentAmountForPaymentSchedule" className="field-label">
                                      Installment Amount<span className="required">*</span>
                                    </label>
                                    <div className="amount-input-wrapper">
                            <span className="currency-symbol">$</span>
                                    <Field name="totalAmount">
                                      {({ field }) => (
                                        <input
                                          type="number"
                                          step="0.01"
                                          id="installmentAmountForPaymentSchedule"
                                          className="field-input amount-input"
                                          disabled={values.frequency === "Onetime"}
                                          min="1"
                                          value={field.value}
                                          onWheel={(e) => e.target.blur()}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            if (
                                              scheduleOtherAmountSection &&
                                              (otherAmountValue === 0 ||
                                                otherAmountValue === null ||
                                                otherAmountValue === "")
                                            ) {
                                              SetInstallmentAmountErrorMessage(
                                                "Enter a valid other amount"
                                              );
                                            } else {
                                              if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                setFieldValue("totalAmount", value);
                                              }
                                            }
                                          }}
                                          onKeyDown={() =>
                                            SetInstallmentAmountErrorMessage("")
                                          }
                                        />
                                      )}
                                    </Field>
                                    </div>
                                    <div className="Error-msg">
                                      <ErrorMessage
                                        name="totalAmount"
                                        component="span"
                                        className="text-danger"
                                      />
                                      <span className="text-danger">
                                        &nbsp;{installmentAmountErrorMessage}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="config-field align-center">
                                    <button
                                      type="submit"
                                      id="generateScheduleBtn" className="btn-secondary"
                                      // disabled={ paymentSchedule?.amounts?.length > 0 ? true : false }
                                      disabled={
                                        paymentData.actualBalance == 0 ||
                                        paymentStatus ||
                                        paymentPlanStatus || merchantStatus
                                      }
                                    >
                                      Generate Payment Schedule{isLoading && <CircularProgress size={16} style={{ color:"white" , marginLeft: 8 }} />}
                                    </button>
                                  </div>
                                </div>
                              </div>

                            </Form>
                          );
                        }}
                      </Formik>



                      {/* Payment Schedule Table (Hidden until generated) */}
                      {paymentSchedule && isPaymentPlanVisible && (<div className="payment-schedule-wrapper" id="paymentScheduleWrapper">
                        <div className="schedule-header">
                          <h4 className="schedule-title">Payment Schedule</h4>
                          {/* <button type="button" id="editScheduleBtn" className="btn-link">
                            <i className='bx bx-edit'></i> Edit Schedule
                          </button> */}
                        </div>

                        <div className="schedule-table-wrapper">
                          <table className="schedule-table" id="scheduleTable">
                            <thead>
                              <tr>
                                <th>Sr. No.</th>
                                <th>Schedule Date</th>
                                <th>Schedule Amount</th>
                                <th>Convenience Fee*</th>
                                <th>Total</th>
                              </tr>
                            </thead>
                            <tbody id="scheduleTableBody">
  {paymentSchedule.dates.map((date, index) => {
    const amount = Number(paymentSchedule.amounts[index]);
    const convenienceFee = Number(paymentSchedule.convenienceList[index] || 0);

    return (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{formatLocalDate(date)}</td>
        <td>${amount.toFixed(2)}</td>
        <td>${convenienceFee.toFixed(2)}</td>
        <td>${(amount + convenienceFee).toFixed(2)}</td>
      </tr>
    );
  })}
</tbody>
<tfoot>
  <tr className="schedule-total-row">
    <td colSpan={2}><strong>Total</strong></td>

    {/* Total Schedule Amount */}
    <td>
      <strong id="totalScheduleAmount">
        ${paymentSchedule.amounts
          .reduce((sum, amt) => sum + Number(amt), 0)
          .toFixed(2)}
      </strong>
    </td>

    {/* Total Convenience Fee */}
    <td>
      <strong id="totalConvenienceFee">
        ${paymentSchedule.convenienceList
          .reduce((sum, fee) => sum + Number(fee), 0)
          .toFixed(2)}
      </strong>
    </td>

    {/* Grand Total */}
    <td>
      <strong id="grandTotal">
        ${(paymentSchedule.amounts.reduce((sum, amt) => sum + Number(amt), 0) +
          paymentSchedule.convenienceList.reduce((sum, fee) => sum + Number(fee), 0)
        ).toFixed(2)}
      </strong>
    </td>
  </tr>
</tfoot>
                          </table>
                        </div>

                        <div className="schedule-actions">
                          <button type="button" id="deleteScheduleBtn" className="btn btn-outline-danger" onClick={() => {
                            if (window.confirm("Are you sure you want to remove the payment schedule?")) {
                              setPaymentSchedule(null);
                              setIsPaymentPlanVisible(false);
                              setProceedBarOpen(false)
                            }
                          }}>
                            <i className='bx bx-trash'></i> Delete Schedule
                          </button>
                          {/* <div className="schedule-summary">
                            <p className="summary-text">
                              <i className='bx bx-check-circle'></i>
                              Schedule completes within <strong id="scheduleMonths">6 months</strong>
                            </p>
                          </div> */}
                        </div>
                        <div className="schedule-disclaimer mt-4" id="offerscheduledDisclaimer">
                                <div className="schedule-disclaimer-icon">
                                    <i className="bx bx-error"></i>
                                </div>
                                <div className="schedule-disclaimer-content">
                                    <p className="xxsmall fw-m mb-2">Failed payments may cancel this offer; previous payments will then apply to the balance.</p>
                                    <p className="xxsmall fw-m">*Applies to card payments only. Select E-Check for a free payment option.</p>
                                </div>
                            </div>
                      </div>)}
                    </div>)}

                  {/* Partial Payment Configuration */}
                  {showPartial && (<div className="partial-config" id="partialConfig">
                    <div className="config-header">
                      <h4 className="config-title text-balance">Enter Partial Payment Amount</h4>
                      <p className="config-subtitle text-balance">Pay any amount toward your balance today</p>
                    </div>

                    <div className="config-form">
                      <div className="config-row">
                        <div className="config-field">
                          <label htmlFor="partialAmount" className="field-label">
                            Payment Amount
                            <span className="required">*</span>
                          </label>
                          <div className="amount-input-wrapper">
                            <span className="currency-symbol">$</span>
                            <input
                              type="number"
                              id="partialAmount"
                              className="field-input amount-input"
                              placeholder="0.00"
                              min="0.01"
                              step="0.01"
                              max={paymentData.actualBalance}
                              value={partialPaymentAmount}
                              onWheel={(e) => e.target.blur()}
                              onChange={(e) => {     const value = e.target.value;

    // Allow empty input
    if (value === "") {
      setPartialPaymentAmount("");
      setPartialAmountError("");
      return;
    }

    // Only numbers with max 2 decimal places
  if (!/^\d*\.?\d{0,2}$/.test(value)) {
    return; // ignore invalid input
  }

    const numericValue = parseFloat(value);
    const maxValue = parseFloat(paymentData.actualBalance);

    // 🚫 Stop if exceeds max
    if (numericValue > maxValue) {
      setPartialAmountError(
        `Amount cannot be greater than $${maxValue.toFixed(2)}`
      );
      return; // ⛔ DO NOT update state
    }

    // ✅ Valid value
    setPartialAmountError("");
                              
                              formikRefRemainingPartialPayment?.current?.resetForm(); SetInstallmentAmountErrorMessagePartialPayment(""); setPartialPaymentAmount(e.target.value); updateConvenienceForPartial(e.target.value); setShowRemainingInstallmentPartialPayment(false) }}
                            />
                          </div>{partialAmountError && (
  <div className="text-danger mt-1 xxxsmall">
    {partialAmountError}
  </div>
)}
                          {/* <p className="field-hint">
                            <i className='bx bx-info-circle'></i> Enter amount between $0.01 and ${paymentData.actualBalance}
                          </p> */}
                        </div>
                      </div>

                      <div className="partial-summary-wrapper">
                      <div className="partial-summary">
                        <div className="partial-summary-row">
                          <span className="partial-summary-label">Amount:</span>
                          <span className="partial-summary-value" id="partialPayingToday">${partialPaymentAmount || "0.00"}</span>
                        </div>
                        <div className="partial-summary-row">
                          <span className="partial-summary-label">Convenience Fee*:</span>
                          <span className="partial-summary-value" id="">${Number(convenienceFeePartialPayment || 0).toFixed(2)}</span>
                        </div>
                        <div className="partial-summary-row">
                          <span className="partial-summary-label">Total Amount:</span>
                          <span className="partial-summary-value" id="partialPayingTodayPlusConvenience">${(Number(partialPaymentAmount) + Number(convenienceFeePartialPayment) + 0).toFixed(2)}</span>
                        </div>
                      </div>
                      <div className="ach-disclaimer-wrapper">
                                <div className="ach-disclaimer-content">
                                    <p className="xxsmall fw-m">*Applies to card payments only. Select E-Check for a free payment option.</p>
                                </div>
                            </div>
                        </div>

                      {AccountInfo.setCount > 1 || paymentPlanStatus || paymentStatus || !paymentData.planAllow ? "" : <div className="partial-summary">
                        <div className="partial-summary-row">
                          <span className="partial-summary-label">Remaining Balance:</span>
                          <span className="partial-summary-value" id="partialRemainingBalance">${(paymentData.actualBalance - partialPaymentAmount).toFixed(2)}</span>
                        </div>
                        <div className="partial-summary-row">
                          <span className="partial-summary-label text-dark">
                            Would you like to schedule the plan for Remaining Balance
                          </span>
                          <span className="partial-summary-value">
                            <label className="custom-toggle-switch">
                              <input type="checkbox" className="custom-toggle-switch__input" id="partialRemainingYes"
                                role="checkbox"
                                aria-checked="false"
                                aria-label="Schedule plan for remaining balance"
                              checked={showRemainingInstallmentPartialPayment}
                                onChange={(e) => {
                                  if (partialPaymentAmount < 0.01) {
                                    alert("Please enter a valid partial payment amount first.");
                                    return
                                  }
                                  else if(partialPaymentAmount > paymentData.actualBalance) {
                                    alert(`Partial payment cannot exceed ${paymentData.actualBalance}`);
                                    return
                                  }
                                  else{
                                    setProceedBarOpen(!e.target.checked)
                                    setShowRemainingInstallmentPartialPayment(e.target.checked)
                                  }}}
                                   />
                              <span className="custom-toggle-switch__slider"></span>
                            </label>
                          </span>
                        </div>
                      </div>}
                    </div>
                  </div>
                  )}
                  {/* Remaining Installment Configuration */}
                  {showRemainingInstallment && (<div className="installment-config" id="remainingInstallmentConfig">
                    <div className="config-header">
                      <h4 className="config-title text-balance">Configure Your Payment Schedule</h4>
                      <p className="config-subtitle text-balance">Set up your installment plan below</p>
                    </div>

                    
                     {/* Installment form for special offer */}
                      <Formik
                        innerRef={formikRefRemainingSpecialOffer}
                        initialValues={{
                          frequencySpecialOffer: "",
                          startDateSpecialOffer: "",
                          totalAmountSpecialOffer: externalStateTotalAmountSpecialOffer,
                        }}
                        validationSchema={validationSchemaSpecialOffer}
                        onSubmit={handleSubmitSpecialOffer}
                      >
                        {({ setFieldValue, values }) => {
                          return (
                            <div className="config-form">
                            <Form
                              id="paymentForm"
                              className=" "
                              style={{ display: paymentFormVisibleSpecialOffer ? "" : "none" }}
                            >
                              <div className="config-row">
                                <div className="config-field">
                                  <label htmlFor="frequencySpecialOffer" className="field-label">
                                    Payment Frequency
                                    <span className="required">*</span>
                                  </label>
                                  <Field
                                    as="select"
                                    name="frequencySpecialOffer"
                                    className="field-input"
                                    ref={frequencyRefSpecialOffer}
                                    onChange={(e) => {
                                      const selectedFrequency = e.target.value;
                                      setFieldValue("frequencySpecialOffer", selectedFrequency);
                                      setExternalFrequencyValueSpecialOffer(e.target.value);
                                      //console.log("freq", e.target.value)

                                      if (selectedFrequency === "Onetime") {
                                        SetInstallmentAmountErrorMessageSpecialOffer("");

                                        setFieldValue(
                                          "totalAmountSpecialOffer",
                                          paymentData.settlementBalance
                                        );
                                      } else {
                                        setFieldValue("totalAmountSpecialOffer", "");
                                        let numInstallments = 1;

                                        const getAllowedInstallments = () => {
                                          switch (e.target.value) {
                                            case "Weekly":
                                              return 26;
                                            case "BiWeekly":
                                              return 13;
                                            case "Monthly":
                                              return 6;
                                            case "Quaterly":
                                              return 2;
                                            case "Onetime":
                                              return 1;
                                            default:
                                              return 6;
                                          }
                                        };

                                        const allowedInstallments =
                                          getAllowedInstallments();

                                        if (allowedInstallments > 1) {
                                          const minRequired = paymentData.settlementBalance / allowedInstallments;

                                          setMinRequiredAmountSpecialOffer(minRequired);

                                          if (
                                            e.target.value !== "Onetime" &&
                                            e.target.value !== "Choose frequency"
                                          ) {
                                            SetInstallmentAmountErrorMessageSpecialOffer(
                                              `Minimum installment amount can be $ ${Math.ceil(
                                                minRequired
                                              )} for ${e.target.value}`
                                            );
                                          } else {
                                            SetInstallmentAmountErrorMessageSpecialOffer("");
                                          }
                                        }
                                       // console.log("minRequiredAmount", minRequiredAmountSpecialOffer)
                                      }
                                    }}
                                  >
                                    <option value={null}>Choose frequency</option>
                                    <option value="Onetime">One Time</option>
                                    <option value="Weekly">Weekly</option>
                                    <option value="BiWeekly">Bi-Weekly</option>
                                    <option value="Monthly">Monthly</option>
                                    <option value="Quaterly">Quarterly</option>
                                  </Field>
                                  <div className="Error-msg">
                                    <ErrorMessage
                                      name="frequencySpecialOffer"
                                      component="span"
                                      className="text-danger"
                                    />
                                  </div>
                                </div>
                                <div className="config-field">
                                  <label htmlFor="startDateSpecialOffer" className="field-label">
                                    Start Date
                                  <span className="required">*</span>
                                  </label>

                                  <Field
                                    type="date"
                                    name="startDateSpecialOffer"
                                    format="MM/dd/yyyy"
                                    className="field-input"
                                    min={
                                      isPayNowAndScheduleChecked
                                        ? new Date(Date.now() + 86400000) // adds 1 day in milliseconds
                                          .toLocaleDateString("en-CA") // formats to 'YYYY-MM-DD'
                                        : new Date().toLocaleDateString("en-CA") // current date in local time
                                    }
                                    max={
                                      new Date(
                                        Date.now() + 25 * 86400000
                                      ).toLocaleDateString("en-CA") // formats to 'YYYY-MM-DD'
                                    }
                                    onBlur={(e) => {
                                      const value = e.target.value;
                                      const year = value.split("-")[0];
                                      if (year.length > 4 || year.length < 4) {
                                        alert("Invalid Date");
                                      }
                                    }}
                                  />

                                  <div className="Error-msg">
                                    <ErrorMessage
                                      name="startDateSpecialOffer"
                                      component="span"
                                      className="text-danger"
                                    />
                                  </div>
                                </div>
                              </div>
                                <div className="config-row">
                                  <div className="config-field">
                                    <label htmlFor="installmentAmountSpecialOffer" className="field-label">
                                      Installment Amount<span className="required">*</span>
                                    </label>
                                    <div className="amount-input-wrapper">
                                    <span className="currency-symbol">$</span>
                                    <Field name="totalAmountSpecialOffer">
                                      {({ field }) => (
                                        <input
                                          type="number"
                                          step="0.01"
                                          className="field-input amount-input"
                                          id="installmentAmountSpecialOffer"
                                          disabled={values.frequencySpecialOffer === "Onetime"}
                                          min="1"
                                          value={field.value}
                                          onWheel={(e) => e.target.blur()}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            if (
                                              scheduleOtherAmountSection &&
                                              (otherAmountValue === 0 ||
                                                otherAmountValue === null ||
                                                otherAmountValue === "")
                                            ) {
                                              SetInstallmentAmountErrorMessageSpecialOffer(
                                                "Enter a valid other amount"
                                              );
                                            } else {
                                              if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                setFieldValue("totalAmountSpecialOffer", value);
                                              }
                                            }
                                          }}
                                          onKeyDown={() =>
                                            SetInstallmentAmountErrorMessageSpecialOffer("")
                                          }
                                        />
                                      )}
                                    </Field>
                                             </div>
                                    <div className="Error-msg">
                                      <ErrorMessage
                                        name="totalAmountSpecialOffer"
                                        component="span"
                                        className="text-danger"
                                      />
                                      <span className="text-danger">
                                        &nbsp;{installmentAmountErrorMessageSpecialOffer}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="config-field align-center">
                                    <button
                                      type="submit"
                                      id="generateScheduleBtn" className="btn-secondary"
                                      // disabled={ paymentSchedule?.amounts?.length > 0 ? true : false }
                                      disabled={
                                        paymentData.settlementBalance == 0 ||
                                        paymentStatus ||
                                        paymentPlanStatus || merchantStatus
                                      }
                                    >
                                      Generate Payment Schedule{isLoading && <CircularProgress size={16} style={{ color:"white" , marginLeft: 8 }} />}
                                    </button>
                                  </div>
                                </div>
                            </Form>
                            </div>
                          );
                        }}
                      </Formik>
                    

                    {/* Remaining Payment Schedule Table special offer (Hidden until generated) */}
                    {paymentScheduleSpecialOffer && isPaymentPlanVisibleSpecialOffer && (<div className="payment-schedule-wrapper" id="remainingPaymentScheduleWrapper">
                      <div className="schedule-header">
                        <h4 className="schedule-title">Payment Schedule</h4>
                        {/* <button type="button" id="editScheduleBtnRemaining" className="btn-link">
                          <i className='bx bx-edit'></i> Edit Schedule
                        </button> */}
                      </div>

                      <div className="schedule-table-wrapper">
                        <table className="schedule-table" id="scheduleTable">
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              <th>Schedule Date</th>
                              <th>Schedule Amount</th>
                              <th>Convenience Fee*</th>
                              <th>Total</th>
                            </tr>
                          </thead>
                          <tbody id="scheduleTableBody">
  {paymentScheduleSpecialOffer.dates.map((date, index) => {
    const amount = Number(paymentScheduleSpecialOffer.amounts[index]);
    const convenienceFee = Number(
      paymentScheduleSpecialOffer.convenienceList[index] || 0
    );

    return (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{formatLocalDate(date)}</td>
        <td>${amount.toFixed(2)}</td>
        <td>${convenienceFee.toFixed(2)}</td>
        <td>${(amount + convenienceFee).toFixed(2)}</td>
      </tr>
    );
  })}
</tbody>
<tfoot>
  <tr className="schedule-total-row">
    <td colSpan={2}>
      <strong>Total</strong>
    </td>

    {/* Total Schedule Amount */}
    <td>
      <strong id="totalScheduleAmount">
        ${paymentScheduleSpecialOffer.amounts
          .reduce((sum, amt) => sum + Number(amt), 0)
          .toFixed(2)}
      </strong>
    </td>

    {/* Total Convenience Fee */}
    <td>
      <strong id="totalConvenienceFee">
        ${paymentScheduleSpecialOffer.convenienceList
          .reduce((sum, fee) => sum + Number(fee), 0)
          .toFixed(2)}
      </strong>
    </td>

    {/* Grand Total */}
    <td>
      <strong id="grandTotal">
        ${(
          paymentScheduleSpecialOffer.amounts.reduce(
            (sum, amt) => sum + Number(amt),
            0
          ) +
          paymentScheduleSpecialOffer.convenienceList.reduce(
            (sum, fee) => sum + Number(fee),
            0
          )
        ).toFixed(2)}
      </strong>
    </td>
  </tr>
</tfoot>
                        </table>
                      </div>

                      <div className="schedule-actions">
                        <button type="button" id="deleteScheduleBtnRemaining" className="btn btn-outline-danger" onClick={() => {
                          if (window.confirm("Are you sure you want to remove the payment schedule?")) {
                            setPaymentScheduleSpecialOffer(null);
                            setIsPaymentPlanVisibleSpecialOffer(false);
                            setProceedBarOpen(false);
                          }
                        }}>
                          <i className='bx bx-trash'></i> Delete Schedule
                        </button>
                        {/* <div className="schedule-summary">
                          <p className="summary-text">
                            <i className='bx bx-check-circle'></i>
                            Schedule completes within <strong id="scheduleMonthsRemaining">6 months</strong>
                          </p>
                        </div> */}
                      </div>
                      <div className="schedule-disclaimer mt-4" id="offerscheduledDisclaimer">
                                <div className="schedule-disclaimer-icon">
                                    <i className="bx bx-error"></i>
                                </div>
                                <div className="schedule-disclaimer-content">
                                    <p className="xxsmall fw-m mb-2">Failed payments may cancel this offer; previous payments will then apply to the balance.</p>
                                    <p className="xxsmall fw-m">*Applies to card payments only. Select E-Check for a free payment option.</p>
                                </div>
                            </div>
                    </div>)}
                  </div>)}



                  {/* Remaining Installment Configuration partial payment  */}
                  {showRemainingInstallmentPartialPayment && (<div className="installment-config" id="remainingInstallmentConfigPartialPayment">
                    <div className="config-header">
                      <h4 className="config-title text-balance">Configure Your Payment Schedule</h4>
                      <p className="config-subtitle text-balance">Set up your installment plan below</p>
                    </div>

                    
                       {/* Installment form for partial payment */}
                      <Formik
                        innerRef={formikRefRemainingPartialPayment}
                        initialValues={{
                          frequencyPartialPayment: "",
                          startDatePartialPayment: "",
                          totalAmountPartialPayment: externalStateTotalAmountPartialPayment,
                        }}
                        validationSchema={validationSchemaPartialPayment}
                        onSubmit={handleSubmitPartialPayment}
                      >
                        {({ setFieldValue, values }) => {
                          return (
                            <div className="config-form">
                            <Form
                              id="paymentForm"
                              className=" "
                              style={{ display: paymentFormVisiblePartialPayment ? "" : "none" }}
                            >
                              <div className="config-row">
                                <div className="config-field">
                                  <label htmlFor="frequencyPartialPayment" className="field-label">
                                    Payment Frequency
                                    <span className="required">*</span>
                                  </label>
                                  <Field
                                    as="select"
                                    name="frequencyPartialPayment"
                                    className="field-input"
                                    ref={frequencyRefPartialPayment}
                                    onChange={(e) => {
                                      const selectedFrequency = e.target.value;
                                      setFieldValue("frequencyPartialPayment", selectedFrequency);
                                      setExternalFrequencyValuePartialPayment(e.target.value);
                                      //console.log("freq", e.target.value)

                                      if (selectedFrequency === "Onetime") {
                                        SetInstallmentAmountErrorMessagePartialPayment("");

                                        const newPartialAmount = Number((paymentData.actualBalance - Number(partialPaymentAmount)).toFixed(2))

                                        setFieldValue(
                                          "totalAmountPartialPayment",
                                          newPartialAmount
                                        );
                                      } else {
                                        setFieldValue("totalAmountPartialPayment", "");
                                        let numInstallments = 1;

                                        const getAllowedInstallments = () => {
                                          switch (e.target.value) {
                                            case "Weekly":
                                              return 26;
                                            case "BiWeekly":
                                              return 13;
                                            case "Monthly":
                                              return 6;
                                            case "Quaterly":
                                              return 2;
                                            case "Onetime":
                                              return 1;
                                            default:
                                              return 6;
                                          }
                                        };

                                        const allowedInstallments =
                                          getAllowedInstallments();

                                        if (allowedInstallments > 1) {

                                          const newPamount = Number((paymentData.actualBalance - Number(partialPaymentAmount)).toFixed(2))

                                          //console.log(newPamount)

                                         // console.log(allowedInstallments)

                                          const minRequired = newPamount / allowedInstallments;

                                         // console.log(minRequired)

                                          setMinRequiredAmountParttialPayment(minRequired);

                                          if (
                                            e.target.value !== "Onetime" &&
                                            e.target.value !== "Choose frequency"
                                          ) {
                                            SetInstallmentAmountErrorMessagePartialPayment(
                                              `Minimum installment amount can be $ ${Math.ceil(
                                                minRequired
                                              )} for ${e.target.value}`
                                            );
                                          } else {
                                            SetInstallmentAmountErrorMessagePartialPayment("");
                                          }
                                        }
                                        //console.log("minRequiredAmount", minRequiredAmountPartialPayment)
                                      }
                                    }}
                                  >
                                    <option value={null}>Choose frequency</option>
                                    <option value="Onetime">One Time</option>
                                    <option value="Weekly">Weekly</option>
                                    <option value="BiWeekly">Bi-Weekly</option>
                                    <option value="Monthly">Monthly</option>
                                    <option value="Quaterly">Quarterly</option>
                                  </Field>
                                  <div className="Error-msg">
                                    <ErrorMessage
                                      name="frequencyPartialPayment"
                                      component="span"
                                      className="text-danger"
                                    />
                                  </div>
                                </div>
                                <div className="config-field">
                                  <label htmlFor="startDatePartialPayment" className="field-label">
                                    Start Date<span className="required">*</span>
                                  </label>

                                  <Field
                                    type="date"
                                    name="startDatePartialPayment"
                                    format="MM/dd/yyyy"
                                    className="field-input"
                                    min={
                                      new Date(Date.now() + 1 * 86400000) // adds 1 day in milliseconds
                                        .toLocaleDateString("en-CA") // formats to 'YYYY-MM-DD'
                                    }
                                    max={
                                      new Date(
                                        Date.now() + 25 * 86400000
                                      ).toLocaleDateString("en-CA") // formats to 'YYYY-MM-DD'
                                    }
                                    onBlur={(e) => {
                                      const value = e.target.value;
                                      const year = value.split("-")[0];
                                      if (year.length > 4 || year.length < 4) {
                                        alert("Invalid Date");
                                      }
                                    }}
                                  />

                                  <div className="Error-msg">
                                    <ErrorMessage
                                      name="startDatePartialPayment"
                                      component="span"
                                      className="text-danger"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="config-row">
                                  <div className="config-field">
                                  <label htmlFor="installmentAmountPartialPayment" className="field-label">
                                    Installment Amount<span className="required">*</span>
                                  </label>
                                  
                                  <Field name="totalAmountPartialPayment">
                                    {({ field }) => (
                                      <div className="amount-input-wrapper">
                            <span className="currency-symbol">$</span>
                                      <input
                                        type="number"
                                        step="0.01"
                                        className="field-input amount-input"
                                        id="installmentAmountPartialPayment"
                                        disabled={values.frequencyPartialPayment === "Onetime"}
                                        min="1"
                                        value={field.value}
                                        onWheel={(e) => e.target.blur()}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          if (
                                            scheduleOtherAmountSection &&
                                            (otherAmountValue === 0 ||
                                              otherAmountValue === null ||
                                              otherAmountValue === "")
                                          ) {
                                            SetInstallmentAmountErrorMessagePartialPayment(
                                              "Enter a valid other amount"
                                            );
                                          } else {
                                            if (/^\d*\.?\d{0,2}$/.test(value)) {
                                              setFieldValue("totalAmountPartialPayment", value);
                                            }
                                          }
                                        }}
                                        onKeyDown={() =>
                                          SetInstallmentAmountErrorMessagePartialPayment("")
                                        }
                                      />
                                      </div>
                                    )}
                                  </Field>
                                 
                                  <div className="Error-msg">
                                    <ErrorMessage
                                      name="totalAmountPartialPayment"
                                      component="span"
                                      className="text-danger"
                                    />
                                    <span className="text-danger">
                                      &nbsp;{installmentAmountErrorMessagePartialPayment}
                                    </span>
                                  </div>
                                </div>

                              <div className="config-field align-center">
                                <button
                                  type="submit"
                                  id="generateScheduleBtn" className="btn-secondary"
                                  // disabled={ paymentSchedule?.amounts?.length > 0 ? true : false }
                                  disabled={
                                    (paymentData.actualBalance - Number(partialPaymentAmount)) == 0 ||
                                    paymentStatus ||
                                    paymentPlanStatus || merchantStatus
                                  }
                                >
                                  Generate Payment Schedule{isLoading && <CircularProgress size={16} style={{ color:"white" , marginLeft: 8 }} />}
                                </button>
                              </div>
                              </div>
                            </Form>
                            </div>
                          );
                        }}
                      </Formik>
                    
                     
                    {/* Remaining Payment Schedule Table partial payment(Hidden until generated) */}
                    {paymentSchedulePartialPayment && isPaymentPlanVisiblePartialPayment && (<div className="payment-schedule-wrapper" id="remainingPaymentScheduleWrapper">
                      <div className="schedule-header"><h4 className="schedule-title">Immediate Payment</h4></div><div className="schedule-table-wrapper"><table className="schedule-table" id="immediatePaymentTable"><thead><tr><th>Payment Date</th><th>Payment Amount</th><th>Convenience Fee *</th><th>Total</th></tr></thead><tbody><tr><td>{new Date(Date.now()).toLocaleDateString("en-US")}</td><td>${partialPaymentAmount}</td><td>${Number(convenienceFeePartialPayment || 0).toFixed(2)}</td><td>${(Number(partialPaymentAmount) + Number(convenienceFeePartialPayment) + 0).toFixed(2)}</td></tr></tbody></table></div>
                      <div className="schedule-header">
                        <h4 className="schedule-title">Payment Schedule</h4>
                        {/* <button type="button" id="editScheduleBtnRemaining" className="btn-link">
                          <i className='bx bx-edit'></i> Edit Schedule 
                        </button> */}
                      </div>

                      <div className="schedule-table-wrapper">
                        <table className="schedule-table" id="scheduleTable">
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              <th>Schedule Date</th>
                              <th>Schedule Amount</th>
                              <th>Convenience Fee*</th>
                              <th>Total</th>
                            </tr>
                          </thead>
                          <tbody id="scheduleTableBody">
  {paymentSchedulePartialPayment.dates.map((date, index) => {
    const amount = Number(paymentSchedulePartialPayment.amounts[index]);
    const convenienceFee = Number(
      paymentSchedulePartialPayment.convenienceList[index] || 0
    );

    return (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{formatLocalDate(date)}</td>
        <td>${amount.toFixed(2)}</td>
        <td>${convenienceFee.toFixed(2)}</td>
        <td>${(amount + convenienceFee).toFixed(2)}</td>
      </tr>
    );
  })}
</tbody>
<tfoot>
  <tr className="schedule-total-row">
    <td colSpan={2}>
      <strong>Total</strong>
    </td>

    {/* Total Schedule Amount */}
    <td>
      <strong id="totalScheduleAmount">
        ${paymentSchedulePartialPayment.amounts
          .reduce((sum, amt) => sum + Number(amt), 0)
          .toFixed(2)}
      </strong>
    </td>

    {/* Total Convenience Fee */}
    <td>
      <strong id="totalConvenienceFee">
        ${paymentSchedulePartialPayment.convenienceList
          .reduce((sum, fee) => sum + Number(fee), 0)
          .toFixed(2)}
      </strong>
    </td>

    {/* Grand Total */}
    <td>
      <strong id="grandTotal">
        ${(
          paymentSchedulePartialPayment.amounts.reduce(
            (sum, amt) => sum + Number(amt),
            0
          ) +
          paymentSchedulePartialPayment.convenienceList.reduce(
            (sum, fee) => sum + Number(fee),
            0
          )
        ).toFixed(2)}
      </strong>
    </td>
  </tr>
</tfoot>
                        </table>
                      </div>

                      <div className="schedule-actions">
                        <button type="button" id="deleteScheduleBtnRemaining" className="btn btn-outline-danger" onClick={() => {
                          if (window.confirm("Are you sure you want to remove the payment schedule?")) {
                            setPaymentSchedulePartialPayment(null);
                            setIsPaymentPlanVisiblePartialPayment(false);
                            setProceedBarOpen(false);
                          }
                        }}>
                          <i className='bx bx-trash'></i> Delete Schedule
                        </button>
                        {/* <div className="schedule-summary">
                          <p className="summary-text">
                            <i className='bx bx-check-circle'></i>
                            Schedule completes within <strong id="scheduleMonthsRemaining">6 months</strong>
                          </p>
                        </div> */}
                      </div>
                      <div className="schedule-disclaimer mt-4" id="offerscheduledDisclaimer">
                                <div className="schedule-disclaimer-icon">
                                    <i className="bx bx-error"></i>
                                </div>
                                <div className="schedule-disclaimer-content">
                                    <p className="xxsmall fw-m mb-2">If you fail to make any of these payments, the plan will automatically cancel.</p>
                                    <p className="xxsmall fw-m">*Applies to card payments only. Select E-Check for a free payment option.</p>
                                </div>
                            </div>
                    </div>)}
                  </div>)}

                  {/* Proceed Bars */}
                  {/* {specialOffer && (
      <div
      className="proceed-total-bar"
      id="proceedOffer"
    >
      <div className="proceed-total-content">
        <div className="proceed-total-left">
          <p className="proceed-total-label mb-1">Offer Amount</p>
          <h5 className="proceed-total-amount mb-0">${paymentData.settlementBalance}</h5>
        </div>
        <div className="proceed-total-right">
          <button className="btn-proceed"
          onClick={handleOfferPaymentSubmit}
          >Proceed to Pay</button>
        </div>
      </div>
    </div>
    )}

    {payFull && (
      <div
      className="proceed-total-bar"
      id="proceedFull"
    >
      <div className="proceed-total-content">
        <div className="proceed-total-left">
          <p className="proceed-total-label mb-1">
            Total for Selected Accounts
          </p>
          <h5 className="proceed-total-amount mb-0">${paymentData.actualBalance}</h5>
        </div>
        <div className="proceed-total-right">
          <button className="btn-proceed" 
          onClick={handlePaymentSubmit}
          >
            Proceed to Pay
            </button>
        </div>
      </div>
    </div>

    )} */}

                  {proceedBarOpen && (<div className="proceed-total-bar" id="continuePayment">
                    <div className="proceed-total-content">
                      <div className="proceed-total-right">
                        <button className="btn-proceed" onClick={() => {
                          if (partial) {
                            if (partialPaymentAmount < 0.01) {
                              alert("Please enter a valid partial payment amount first.");
                            }
                            else if(partialPaymentAmount > paymentData.actualBalance) {
                              alert(`Partial payment cannot exceed ${paymentData.actualBalance}`);
                            }
                            else {
                              setIsCommonModelOpen(true);
                              setIsProcessingPayment(false);
                            }
                          }
                          else {
                            setIsCommonModelOpen(true);
                            setIsProcessingPayment(false);
                          }
                          // console.log("pifFlag , sifFlag , otherPayFlag" , pifFlag , sifFlag , otherPayFlag)
                        }} >
                          Continue to Pay
                        </button>
                      </div>
                    </div>
                  </div>)}

                  {/* {isPaymentPlanVisible && (
       <div className="proceed-total-bar" id="proceedPlan">
       <div className="proceed-total-content">
           <div className="proceed-total-left">
               <p className="proceed-total-label mb-1">Schedule Plan for</p>
               <h5 className="proceed-total-amount mb-0" id="">${paymentData.actualBalance}</h5>
           </div>
           <div className="proceed-total-right">
               <button className="btn-proceed" onClick={handleSchedulePaymentModel}>
                   Schedule Plan
               </button>
           </div>
       </div>
   </div>
    )} */}
                </div>
              </section>
      )
    : ""
}
         
              </>)}


              {/* <!-- End of Payment Plan Section --> */}

                 

            </div>
          </div>)
}
          {/* Help popup (currently disabled) */}
          {/*
<div id="helpPopup" className="helpPopup-section">
  <p>
    If you need any assistance while making payment, kindly contact us at{" "}
    <b>1-855-880-4791</b>
  </p>
  <button id="close-helpPopup" className="text-primary">
    Close
  </button>
</div>
*/}

         
        </main>

        {/* Disclaimer Modal Pay Full*/}
        {/* {isModelOpen && (
          <div
            className="modal fade show"
            id="Disclaimer"
            tabIndex="-1"
            aria-labelledby="staticBackdropLabel"
            //  aria-hidden="true"
            style={{
              display: "block",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1501,
            }}
          >
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg modal-fullscreen-sm-down">
              <div className="modal-content">
                <div className="modal-header p-2 px-3">
                  <h1 className="paragraph-sm mb-0">Disclosure</h1>
                  <button
                    type="button"
                    className="btn-close xxxsmall"
                    aria-label="Close"
                    onClick={() => {
                      setIsModelOpen(false);
                      setIsChecked(false);
                      setIsBtnDisable(true);
                    }}
                  ></button>
                </div>
                <div className="modal-body " id="staticBackdropLabel">
                  <div className="row">
                    <div className="col-md-12">
                      <p className="xxxsmall">
                        Thank you for visiting the Credence Payment Center.
                        Before proceeding please read the following terms and
                        conditions regarding its use and check the box below to
                        acknowledge you understand and accept them.
                        <br />
                        <b>Disclosure authorization:</b> I am the individual
                        whose name appears as the customer on this account or I
                        have legal authorization to act on behalf of the
                        customer named. If the customer is a minor, an adult
                        under my care, or a business I own or manage, I am duly
                        authorized to represent the named party, disclose
                        personal information and conduct this transaction on
                        their behalf.
                        <br />
                        <b>Contact authorization:</b> I authorize Credence
                        Payment Center and its representatives to contact me by
                        telephone, automatic dialing system or device, email,
                        mail, SMS, chat and/or through this website. I authorize
                        that any attempt to contact me may include, but is not
                        limited to voice, prerecorded or artificial messages,
                        text or electronic messages and calls made by an
                        automated or computer directed telephone dialing system
                        to any phone number or any cellular phone. I agree that
                        both the cell phone number(s), telephone number(s)
                        and/or e-mail addresses that I provide to you are secure
                        and cannot be listened to or viewed by unauthorized
                        third parties.
                      </p>
                      <div className="col-md-12">
                        <div className="disclosure-table">
                          <table className="table mb-3">
                            <tbody>
                              <tr>
                                <td>Amount :</td>
                                <td>${saleAmount || payableAmount}</td>
                              </tr>
                              <tr>
                                <td>Convenience Fee :</td>
                                <td>${convenienceFee || "0.00"}</td>
                              </tr>
                              <tr>
                                <td>Total Amount :</td>
                                <td>${amount || payableAmount + 0.0}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>
                <div className="modal-footer">
                <div className="d-flex justify-content-between w-100">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id=""
                            onChange={() => {
                              setIsChecked(!isChecked);
                              setIsBtnDisable(!isBtnDisable);
                            }}
                          />
                          <label
                            className="form-check-label form-label"
                            htmlFor=""
                          >
                            I Agree
                          </label>
                        </div>
                        <button
                          type="submit"
                          className="btn btn-primary label"
                          onClick={handlePayment}
                          disabled={isBtnDisable}
                        >
                          Proceed To Payment
                        </button>
                      </div>
                    </div>
              </div>
            </div>
          </div>
        )} */}

        {/* Disclaimer Modal Pay Schedule*/}
        {/* {isScheduleModelOpen && (
                    <div
                      className="modal fade show"
                      id="Disclaimer"
                      tabIndex="-1"
                      aria-labelledby="staticBackdropLabel"
                      style={{
                        display: "block",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        zIndex: 1501,
                      }}
                    >
                      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg modal-fullscreen-sm-down">
                        <div className="modal-content">
                          <div className="modal-header p-2 px-3">
                            <h1 className="paragraph-sm mb-0">Disclosure</h1>
                            <button
                              type="button"
                              className="btn-close xxxsmall"
                              aria-label="Close"
                              onClick={() => {
                                setIsScheduleModelOpen(false);
                                setIsScheduleChecked(false);
                              }}
                            ></button>
                          </div>
                          <div className="modal-body " id="staticBackdropLabel">
                            <div className="row">
                              <div className="col-md-12">
                                <p className="xxxsmall">
                                  Thank you for visiting the Credence Payment
                                  Center. Before proceeding please read the
                                  following terms and conditions regarding its
                                  use and check the box below to acknowledge you
                                  understand and accept them.
                                  <br />
                                  <b>Disclosure authorization:</b> I am the
                                  individual whose name appears as the customer
                                  on this account or I have legal authorization
                                  to act on behalf of the customer named. If the
                                  customer is a minor, an adult under my care,
                                  or a business I own or manage, I am duly
                                  authorized to represent the named party,
                                  disclose personal information and conduct this
                                  transaction on their behalf.
                                  <br />
                                  <b>Contact authorization:</b> I authorize
                                  Credence Payment Center and its
                                  representatives to contact me by telephone,
                                  automatic dialing system or device, email,
                                  mail, SMS, chat and/or through this website. I
                                  authorize that any attempt to contact me may
                                  include, but is not limited to voice,
                                  prerecorded or artificial messages, text or
                                  electronic messages and calls made by an
                                  automated or computer directed telephone
                                  dialing system to any phone number or any
                                  cellular phone. I agree that both the cell
                                  phone number(s), telephone number(s) and/or
                                  e-mail addresses that I provide to you are
                                  secure and cannot be listened to or viewed by
                                  unauthorized third parties.
                                </p>
                              </div>
                              
                            </div>
                          </div>
                          <div className="modal-footer">
                              <div className="d-flex justify-content-between w-100">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value=""
                                      id=""
                                      onChange={() =>{
                                        setIsScheduleChecked((prev) => !prev);
                                        setIsScheduleBtnDisable(!isBtnDisable);}
                                      }
                                    />
                                    <label
                                      className="form-check-label form-label"
                                      htmlFor=""
                                    >
                                      I Agree
                                    </label>
                                  </div>
                                  <button
                                    type="submit"
                                    className="btn btn-primary label"
                                    onClick={handleSchedulePaymentSubmit}
                                    disabled={!isScheduleChecked || isScheduleBtnDisable}
                                  >
                                    Proceed To Payment
                                  </button>
                                </div>
                                </div>
                        </div>
                      </div>
                    </div>
                  )}         */}
      {/* </div> */}

      {
  showModal &&
  !(
    paymentPlanStatus ||
    String(paymentData.actualBalance) === '0' ||
    String(paymentData.actualBalance) === '0.00' ||
    String(paymentData.actualBalance) === '0.0000' ||
    paymentData.actualBalance === 0 ||
    paymentData.specialOfferPay ||
    paymentData.payInFull ||
    (Number(paymentData.actualBalance) - Number(paymentData.paidAmount) === 0)
  ) && (
    <>
          {/* Backdrop */}
          <div className="modal-backdrop fade show" aria-label="Select Your State or Territory"></div>

          {/* Modal */}
          <FocusTrap
  focusTrapOptions={{
    escapeDeactivates: false
  }}
>
          <div className="modal fade show d-block Statemodal">
            <div className="modal-dialog modal-dialog-centered modal-md">
              <div className="modal-content">
                <div className="modal-body">
                  <label className="paragraph-md mb-3 fw-m">
                   Please select your state or territory
                  </label>
                  <select
                    className="form-select"
                    value={selectedState}
                    onChange={(e) => setSelectedState(e.target.value)}
                  >
                    <option value="" disabled>- Select State or Territory-</option>

                    {stateList.map((item) => (
                      <option key={item.stateID} value={item.stateCode}>
                        {item.stateName}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-outline"
                    onClick={() => setSelectedState("")}
                  >
                    Clear
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={handleStateUpdate}
                    disabled={!selectedState}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          </FocusTrap>
        </>
      )}
      {/* Common Model*/}
      {isCommonModelOpen && (
        <div
          className="modal fade show"
          id="Disclaimer"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          //  aria-hidden="true"
          style={{
            display: "block",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1501,
          }}
        >
       <FocusTrap
  focusTrapOptions={{
    escapeDeactivates: false
  }}
>
       <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg modal-fullscreen-sm-down">
            <div className="modal-content">
              <div className="modal-header">
                <h3 className="mb-0">Disclosure</h3>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => {
                  setIsCommonModelOpen(false);setIsAgreed(false);setIsProcessingPayment(false)
                }}></button>
              </div>
              <div className="modal-body " id="staticBackdropLabel">
                <div className="row">
                  <div className="col-md-12">
                    <p className="xxxsmall mb-2">
                      Thank you for visiting the Credence Payment Center.
                      Before proceeding please read the following terms and conditions regarding its use and check the box
                      below
                      to
                      acknowledge you understand and accept them.
                    </p>
                    <p className="xxxsmall">
                      <b>Disclosure authorization:</b> I am the individual whose name appears as the customer on this account
                      or I
                      have legal
                      authorization to act on behalf of the customer named.
                      If the customer is a minor, an adult under my care, or a business I own or manage,
                      I am duly authorized to represent the named party, disclose personal information and conduct this
                      transaction on their
                      behalf.
                    </p>
                  </div>

                </div>
              </div>
              <div className="modal-footer justify-content-between">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" checked={isAgreed}
                   onChange={(e) => setIsAgreed(e.target.checked)}/>
                  <label className="form-check-label form-label" for="">
                    I Agree
                  </label>
                </div>
                <button
  type="button"
  className="btn btn-primary label"
  disabled={!isAgreed || isProcessingPayment}
  onClick={handlePayments}
>
  Proceed To Payment
</button>
              </div>
            </div>
          </div>
       </FocusTrap>
        </div>
      )}
</>
      
  
  );
}

